import {debounce, animateBlock, addSubmenuButton, anchorLinks, lazyImage} from './modules/helpers.js';
import initFakeSelects  from './modules/initFakeSelects';

// Take some useful functions
import {
	closest_polyfill,
} from './modules/helpers.js';

/**
 * All custom code is wrapped in IIFE function
 * to prevent affect our code to another parts of code
 */
;(function ( $ ) {
    
    lazyImage();

	const corppixI18n =
		typeof var_from_php !== 'undefined' &&
		var_from_php &&
		var_from_php.i18n &&
		typeof var_from_php.i18n === 'object'
			? var_from_php.i18n
			: {};

	const t = ( key, fallback = '' ) => {
		const v = corppixI18n && Object.prototype.hasOwnProperty.call( corppixI18n, key ) ? corppixI18n[ key ] : undefined;
		if ( v == null ) {
			return fallback;
		}
		const s = String( v );
		return s.trim() === '' ? fallback : s;
	};
    
	function corppixConfirmLiqPayPayment( orderId, orderKey, callbackData ) {
		if (
			typeof var_from_php === 'undefined'
			|| ! var_from_php.ajax_url
			|| ! var_from_php.liqpay_confirm_nonce
			|| ! orderId
			|| ! orderKey
		) {
			return Promise.resolve( false );
		}

		const fd = new FormData();
		fd.append( 'action', 'corppix_liqpay_confirm' );
		fd.append( 'nonce', var_from_php.liqpay_confirm_nonce );
		fd.append( 'order_id', String( orderId ) );
		fd.append( 'order_key', String( orderKey ) );

		if ( callbackData && callbackData.data && callbackData.signature ) {
			fd.append( 'data', String( callbackData.data ) );
			fd.append( 'signature', String( callbackData.signature ) );
		}

		return fetch( var_from_php.ajax_url, {
			method: 'POST',
			credentials: 'same-origin',
			body: fd,
		} )
			.then( ( r ) => r.json() )
			.then( ( res ) => Boolean( res && res.success && res.data && res.data.paid ) )
			.catch( () => false );
	}

	function corppixWaitForLiqPayCheckout( maxAttempts, delayMs ) {
		const attempts = Number.isFinite( maxAttempts ) ? maxAttempts : 40;
		const delay = Number.isFinite( delayMs ) ? delayMs : 100;

		return new Promise( ( resolve ) => {
			let tries = 0;
			const tick = () => {
				if (
					typeof window.LiqPayCheckout !== 'undefined'
					&& typeof window.LiqPayCheckout.init === 'function'
				) {
					resolve( true );
					return;
				}
				tries += 1;
				if ( tries >= attempts ) {
					resolve( false );
					return;
				}
				window.setTimeout( tick, delay );
			};
			tick();
		} );
	}

	function corppixInitLiqpayEmbed() {
		if (
			typeof var_from_php === 'undefined'
			|| ! var_from_php.corppix_liqpay_embed
			|| ! document.getElementById( 'corppix-liqpay-checkout' )
		) {
			return;
		}

		const cfg = var_from_php.corppix_liqpay_embed;
		if ( ! cfg.data || ! cfg.signature ) {
			return;
		}

		corppixWaitForLiqPayCheckout().then( ( ready ) => {
			if ( ! ready || typeof window.LiqPayCheckout === 'undefined' ) {
				return;
			}

			const lang = cfg.language || 'uk';

			try {
				window.LiqPayCheckout.init( {
					data: cfg.data,
					signature: cfg.signature,
					mode: 'embed',
					embedTo: '#corppix-liqpay-checkout',
					language: lang,
				} ).on( 'liqpay.callback', function ( callbackData ) {
					if ( ! callbackData || ! callbackData.status ) {
						return;
					}
					if (
						callbackData.status === 'success'
						|| callbackData.status === 'sandbox'
						|| callbackData.status === 'wait_accept'
					) {
						const goThanks = function () {
							if ( cfg.redirect_after_pay ) {
								window.location.assign( cfg.redirect_after_pay );
							}
						};

						if ( ! cfg.order_id || ! cfg.order_key ) {
							goThanks();
							return;
						}

						corppixConfirmLiqPayPayment( cfg.order_id, cfg.order_key, callbackData )
							.finally( goThanks );
					}
				} );
			} catch ( liqpayErr ) {
				// LiqPay init failed.
			}
		} );
	}

	function corppixHandlePlaceOrderResponse( data, clickElem, setCheckoutPlaceOrderLoading ) {
		const payload = data && data.data ? data.data : null;

		if ( ! data || data.success !== true || ! payload ) {
			setCheckoutPlaceOrderLoading( false );
			if ( clickElem ) {
				clickElem.disabled = false;
			}
			const errMsg = payload && payload.message ? payload.message : t( 'generic_checkout_error', 'Помилка оформлення.' );
			window.alert( errMsg );
			if ( typeof window.corppixRefreshCheckoutConfirmOrderGate === 'function' ) {
				window.corppixRefreshCheckoutConfirmOrderGate();
			}
			return;
		}

		if ( payload.redirect ) {
			window.location.assign( payload.redirect );
			return;
		}

		setCheckoutPlaceOrderLoading( false );
		if ( clickElem ) {
			clickElem.disabled = false;
		}
		const errMsg = payload.message ? payload.message : t( 'generic_checkout_error', 'Помилка оформлення.' );
		window.alert( errMsg );
		if ( typeof window.corppixRefreshCheckoutConfirmOrderGate === 'function' ) {
			window.corppixRefreshCheckoutConfirmOrderGate();
		}
	}

	/**
	 * Occurs when all HTML has been fully loaded and passed by the parser,
	 * without waiting for the stylesheets, images and frames to finish loading
	 */
	document.addEventListener("DOMContentLoaded", function(event) {
		// Init Closest polyfill method ( Don't delete it )
		closest_polyfill();

		if (
			typeof var_from_php !== 'undefined'
			&& var_from_php.liqpay_thankyou_confirm
			&& var_from_php.liqpay_confirm_nonce
		) {
			const th = var_from_php.liqpay_thankyou_confirm;
			if ( th.order_id && th.order_key ) {
				corppixConfirmLiqPayPayment( th.order_id, th.order_key, null );
			}
		}

		corppixInitLiqpayEmbed();

		(function corppixInitTurnstile() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.turnstile_site_key ) {
				return;
			}

			const siteKey = String( var_from_php.turnstile_site_key || '' ).trim();
			if ( ! siteKey ) {
				return;
			}

			const ensureHidden = ( formEl ) => {
				if ( ! formEl ) return null;
				let inp = formEl.querySelector( 'input[name="cf-turnstile-response"]' );
				if ( ! inp ) {
					inp = document.createElement( 'input' );
					inp.type = 'hidden';
					inp.name = 'cf-turnstile-response';
					inp.className = 'js-turnstile-response';
					formEl.appendChild( inp );
				}
				return inp;
			};

			const waitForApi = () => new Promise( ( resolve, reject ) => {
				if ( typeof window.turnstile !== 'undefined' && window.turnstile && typeof window.turnstile.render === 'function' ) {
					resolve( window.turnstile );
					return;
				}

				const timeout = window.setTimeout( () => {
					reject( new Error( 'Turnstile API load timeout' ) );
				}, 10000 );

				window.corppixTurnstileOnload = function () {
					window.clearTimeout( timeout );
					if ( typeof window.turnstile !== 'undefined' && window.turnstile && typeof window.turnstile.render === 'function' ) {
						resolve( window.turnstile );
					} else {
						reject( new Error( 'Turnstile API is unavailable' ) );
					}
				};
			} );

			window.corppixTurnstileGetToken = function ( formEl ) {
				if ( ! formEl ) {
					return Promise.reject( new Error( 'Turnstile form is missing' ) );
				}

				const hidden = ensureHidden( formEl );
				const currentToken = ( hidden && hidden.value ? hidden.value : '' ).trim();
				if ( currentToken ) {
					return Promise.resolve( currentToken );
				}

				const holder = formEl.querySelector( '.js-turnstile[data-role="turnstile"]' );
				if ( ! holder ) {
					return Promise.reject( new Error( 'Turnstile holder is missing' ) );
				}

				if ( holder._corppixTurnstilePromise ) {
					return holder._corppixTurnstilePromise;
				}

				holder._corppixTurnstilePromise = waitForApi().then( ( turnstileApi ) => new Promise( ( resolve, reject ) => {
					const cleanup = () => {
						holder._corppixTurnstilePromise = null;
					};

					const timeout = window.setTimeout( () => {
						cleanup();
						reject( new Error( 'Turnstile verification timeout' ) );
					}, 15000 );

					const options = {
						sitekey: siteKey,
						size: 'invisible',
						callback: ( token ) => {
							window.clearTimeout( timeout );
							const normalizedToken = String( token || '' );
							if ( hidden ) hidden.value = normalizedToken;
							cleanup();
							normalizedToken ? resolve( normalizedToken ) : reject( new Error( 'Turnstile returned empty token' ) );
						},
						'expired-callback': () => {
							if ( hidden ) hidden.value = '';
						},
						'error-callback': () => {
							window.clearTimeout( timeout );
							if ( hidden ) hidden.value = '';
							cleanup();
							reject( new Error( 'Turnstile verification failed' ) );
						},
					};

					let widgetId = holder.dataset ? holder.dataset.turnstileWidgetId : '';
					if ( ! widgetId ) {
						widgetId = turnstileApi.render( holder, options );
						if ( holder.dataset ) {
							holder.dataset.turnstileWidgetId = String( widgetId );
						}
					}

					turnstileApi.execute( widgetId );
				} ) );

				return holder._corppixTurnstilePromise;
			};

			window.corppixTurnstileResetForm = function ( formEl ) {
				if ( ! formEl || ! formEl.querySelectorAll ) return;
				const hidden = formEl.querySelector( 'input[name="cf-turnstile-response"]' );
				if ( hidden ) hidden.value = '';
				if ( typeof window.turnstile === 'undefined' || ! window.turnstile || typeof window.turnstile.reset !== 'function' ) {
					return;
				}
				formEl.querySelectorAll( '.js-turnstile[data-role="turnstile"]' ).forEach( ( el ) => {
					const id = el.dataset ? el.dataset.turnstileWidgetId : '';
					if ( id ) {
						try { window.turnstile.reset( id ); } catch ( e ) {}
					}
				} );
			};
		}());

		(function corppixInitContactFormConsentToggle() {
			const sync = ( formEl ) => {
				if ( ! formEl ) {
					return;
				}
				const chk = formEl.querySelector( '[data-role="contact-consent"]' ) || formEl.querySelector( '.js-contact-form-confirm' );
				const btn = formEl.querySelector( '[data-role="contact-submit"]' ) || formEl.querySelector( '.js-contact-form-submit' );
				if ( ! btn ) {
					return;
				}
				btn.disabled = !( chk && chk.checked );
			};

			document.querySelectorAll( 'form[data-role="contact-form-order"]' ).forEach( sync );

			document.body.addEventListener( 'change', ( e ) => {
				const t = e.target;
				if ( ! t || ! t.closest ) {
					return;
				}
				if ( ! ( t.matches( '[data-role="contact-consent"]' ) || t.classList.contains( 'js-contact-form-confirm' ) ) ) {
					return;
				}
				const form = t.closest( 'form[data-role="contact-form-order"]' );
				if ( ! form ) {
					return;
				}
				sync( form );
			} );
		}());

		(function corppixInitFormOrderConsentToggle() {
			const sync = ( formEl ) => {
				if ( ! formEl ) {
					return;
				}
				const chk = formEl.querySelector( '[data-role="form-order-consent"]' ) || formEl.querySelector( '.js-contact-form-confirm' );
				const btn = formEl.querySelector( '[data-role="form-order-submit"]' ) || formEl.querySelector( '.js-form-order-submit' );
				if ( ! btn ) {
					return;
				}
				btn.disabled = !( chk && chk.checked );
			};

			document.querySelectorAll( 'form[data-role="form-order"]' ).forEach( sync );

			document.body.addEventListener( 'change', ( e ) => {
				const t = e.target;
				if ( ! t || ! t.closest ) {
					return;
				}
				if ( ! ( t.matches( '[data-role="form-order-consent"]' ) || t.classList.contains( 'js-contact-form-confirm' ) ) ) {
					return;
				}
				const form = t.closest( 'form[data-role="form-order"]' );
				if ( ! form ) {
					return;
				}
				sync( form );
			} );
		}());

		(function corppixInitCookieConsentBanner() {
			const banner = document.querySelector( '.js-cookie-consent-banner' );
			if ( ! banner ) {
				return;
			}
			const COOKIE_NAME = 'corppix_cookie_consent';

			function corppixReadCookieConsent() {
				const escaped = COOKIE_NAME.replace( /([.$?*|{}()[\]\\/+^])/g, '\\$1' );
				const m = document.cookie.match( new RegExp( '(?:^|; )' + escaped + '=([^;]*)' ) );
				return m ? decodeURIComponent( m[ 1 ] ) : '';
			}

			if ( corppixReadCookieConsent() === '1' ) {
				return;
			}

			window.setTimeout( () => {
				if ( ! banner.isConnected || corppixReadCookieConsent() === '1' ) {
					return;
				}
				banner.classList.add( 'is-open' );
				banner.setAttribute( 'aria-hidden', 'false' );
			}, 10000 );
		}());

		function updateCartCountBadges(count) {
			document.querySelectorAll('.js-card-calc').forEach((wrap) => {
				const span = wrap.querySelector('span');
				if (span) span.textContent = String(count);
			});
		}

		function checkoutSyncDeliveryCitySummary( citySelectEl, labelOverride ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			const out = document.querySelector( '.js-checkout-summary-delivery-city' );
			if ( ! out ) {
				return;
			}
			if ( ! citySelectEl ) {
				out.textContent = '-';
				return;
			}
			const forced = labelOverride != null ? String( labelOverride ).trim() : '';
			if ( forced ) {
				out.textContent = forced;
				return;
			}
			let label = '';
			const val = String( citySelectEl.value || '' ).trim();
			if ( val && typeof window.jQuery !== 'undefined' ) {
				try {
					const $c = window.jQuery( citySelectEl );
					if ( $c.data( 'select2' ) || $c.data( 'selectWoo' ) ) {
						const d = $c.selectWoo( 'data' );
						if ( d && d.text != null ) {
							label = String( d.text ).trim();
						}
					}
				} catch ( errSw ) {
				}
			}
			if ( ! label && val ) {
				const opt = citySelectEl.selectedOptions && citySelectEl.selectedOptions[ 0 ];
				if ( opt ) {
					label = String( opt.textContent || '' ).trim();
				}
			}
			out.textContent = label || '-';
		}

		function checkoutSyncDeliveryWarehouseSummary( warehouseSelectEl, labelOverride ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			const out = document.querySelector( '.js-checkout-summary-delivery-warehouse' );
			if ( ! out ) {
				return;
			}
			if ( ! warehouseSelectEl ) {
				out.textContent = '-';
				return;
			}
			const forced = labelOverride != null ? String( labelOverride ).trim() : '';
			if ( forced ) {
				out.textContent = forced;
				return;
			}
			let label = '';
			const val = String( warehouseSelectEl.value || '' ).trim();
			if ( val && typeof window.jQuery !== 'undefined' ) {
				try {
					const $w = window.jQuery( warehouseSelectEl );
					if ( $w.data( 'select2' ) || $w.data( 'selectWoo' ) ) {
						const d = $w.selectWoo( 'data' );
						if ( d && d.text != null ) {
							label = String( d.text ).trim();
						}
					}
				} catch ( errSw ) {
				}
			}
			if ( ! label && val ) {
				const opt = warehouseSelectEl.selectedOptions && warehouseSelectEl.selectedOptions[ 0 ];
				if ( opt ) {
					label = String( opt.textContent || '' ).trim();
				}
			}
			out.textContent = label || '-';
		}

		function checkoutSyncNpPointSummaryLabel( deliveryTypeValue ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			const labelEl = document.querySelector( '.js-checkout-summary-np-point-label' );
			const labels = var_from_php.checkout_np_point_labels;
			if ( ! labelEl || ! labels ) {
				return;
			}
			const isPostomat = deliveryTypeValue === 'parcel-machine';
			const next = isPostomat
				? ( labels.postomat || labels.warehouse )
				: ( labels.warehouse || labelEl.textContent );
			labelEl.textContent = next;
		}

		function checkoutSyncDeliverySummaryAddressRows( deliveryTypeValue ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			const npBlock = document.querySelector( '.js-checkout-summary-delivery-np-rows' );
			const courierBlock = document.querySelector( '.js-checkout-summary-delivery-courier-rows' );
			if ( ! npBlock || ! courierBlock ) {
				return;
			}
			const isCourier = deliveryTypeValue === 'courier-city';
			const isNp = deliveryTypeValue === 'post-office' || deliveryTypeValue === 'parcel-machine';
			if ( isCourier ) {
				npBlock.classList.add( 'hidden' );
				courierBlock.classList.remove( 'hidden' );
			} else if ( isNp ) {
				npBlock.classList.remove( 'hidden' );
				courierBlock.classList.add( 'hidden' );
			} else {
				npBlock.classList.add( 'hidden' );
				courierBlock.classList.add( 'hidden' );
			}
		}

		function checkoutSyncAllCourierSummaryFields( formEl ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout || ! formEl ) {
				return;
			}
			const pick = ( role ) => formEl.querySelector( '[data-role="' + role + '"]' );
			const apply = ( selector, input ) => {
				const el = document.querySelector( selector );
				if ( ! el || ! input ) {
					return;
				}
				const t = String( input.value || '' ).trim();
				el.textContent = t || '-';
			};
			apply( '.js-checkout-summary-courier-city', pick( 'courier-city-input' ) );
			apply( '.js-checkout-summary-courier-street', pick( 'courier-street-input' ) );
			apply( '.js-checkout-summary-courier-house', pick( 'courier-house-input' ) );
			apply( '.js-checkout-summary-courier-apartment', pick( 'courier-apartment-input' ) );
		}

		function checkoutSyncPaymentMethodSummary( paymentRadio ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			const out = document.querySelector( '.js-checkout-summary-payment-method' );
			if ( ! out ) {
				return;
			}
			let el = paymentRadio;
			if ( ! el || ! el.matches || ! el.matches( 'input[name="payment-type"]' ) ) {
				const formEl = document.querySelector( 'form.checkout' );
				el = formEl ? formEl.querySelector( 'input[name="payment-type"]:checked' ) : null;
			}
			if ( ! el || ! el.getAttribute ) {
				out.textContent = '-';
				return;
			}
			const title = el.getAttribute( 'data-title' );
			out.textContent = ( title && String( title ).trim() ) ? String( title ).trim() : '-';
		}

		function refreshSideCartInner() {
			const inner = document.querySelector('.js-side-cart-inner');
			if (!inner || typeof var_from_php === 'undefined' || !var_from_php.ajax_url) {
				return Promise.resolve();
			}
			const fd = new FormData();
			fd.append('action', 'corppix_side_cart_refresh');
			if ( var_from_php.is_checkout ) {
				fd.append( 'include_checkout_order_review_items', '1' );
			}
			return fetch(var_from_php.ajax_url, {
				method: 'POST',
				credentials: 'same-origin',
				body: fd,
			})
				.then((r) => r.json())
				.then((data) => {
					if (data.success && data.data && data.data.html) {
						inner.innerHTML = data.data.html;
					}
					if (data.success && data.data && data.data.cart_count !== undefined) {
						updateCartCountBadges(data.data.cart_count);
					}
					if ( data.success && data.data && data.data.checkout_order_review_items_html !== undefined ) {
						const orderReviewItems = document.querySelector( '.js-checkout-order-review-cart-items' );
						if ( orderReviewItems ) {
							orderReviewItems.innerHTML = data.data.checkout_order_review_items_html;
						}
					}
					if ( data.success && data.data ) {
						corppixApplyCheckoutSidebarFromAjaxData( data.data );
					}
				})
				.catch(() => {});
		}

		function corppixApplyCheckoutSidebarTotals(totals) {
			if (!totals || typeof totals !== 'object') return;
			const lab = document.querySelector('.js-checkout-sidebar-items-label');
			const sub = document.querySelector('.js-checkout-sidebar-subtotal');
			const tot = document.querySelector('.js-checkout-sidebar-order-total');
			if (lab && totals.items_label != null) lab.textContent = totals.items_label;
			if (sub && totals.subtotal_html != null) sub.innerHTML = totals.subtotal_html;
			if (tot && totals.total_html != null) tot.innerHTML = totals.total_html;
		}

		function corppixApplyCheckoutSidebarDiscount(disc) {
			if (!disc || typeof disc !== 'object') return;
			const row = document.querySelector('.js-checkout-sidebar-discount-row');
			const val = document.querySelector('.js-checkout-sidebar-discount-value');
			if (!row || !val) return;
			row.classList.toggle('hidden', !disc.show);
			if (!disc.show) {
				val.innerHTML = '';
			} else if (disc.value_html != null) {
				val.innerHTML = disc.value_html;
			}
		}

		function corppixApplyCheckoutSidebarFromAjaxData(d) {
			if (!d || typeof d !== 'object') return;
			if (d.checkout_sidebar_totals) corppixApplyCheckoutSidebarTotals(d.checkout_sidebar_totals);
			if (d.checkout_sidebar_discount) corppixApplyCheckoutSidebarDiscount(d.checkout_sidebar_discount);
		}

		function corppixGetSideCartLineMinQty(el) {
			const row = el && el.closest ? el.closest('.side-cart__item') : null;
			if (!row) return 1;
			const raw = row.getAttribute('data-corppix-qty-min');
			if (raw == null || raw === '') return 1;
			const n = parseInt(raw, 10);
			return Number.isNaN(n) || n < 1 ? 1 : n;
		}

		function openSideCart() {
			const root = document.querySelector('.js-side-cart');
			const overlay = document.querySelector('.js-side-cart-overlay');
			const panel = document.querySelector('.js-side-cart-panel');
			if (!root || !overlay || !panel) return;
			root.classList.remove('hidden');
			root.setAttribute('aria-hidden', 'false');
			document.body.classList.add('overflow-hidden');
			requestAnimationFrame(() => {
				overlay.classList.remove('opacity-0');
				overlay.classList.add('opacity-100');
				panel.classList.remove('translate-x-full');
				panel.classList.add('translate-x-0');
			});
			refreshSideCartInner();
		}

		function closeSideCart() {
			const root = document.querySelector('.js-side-cart');
			const overlay = document.querySelector('.js-side-cart-overlay');
			const panel = document.querySelector('.js-side-cart-panel');
			if (!root || !overlay || !panel) return;
			overlay.classList.remove('opacity-100');
			overlay.classList.add('opacity-0');
			panel.classList.add('translate-x-full');
			panel.classList.remove('translate-x-0');
			document.body.classList.remove('overflow-hidden');
			setTimeout(() => {
				root.classList.add('hidden');
				root.setAttribute('aria-hidden', 'true');
			}, 280);
		}

		function postSideCartAction(action, extra) {
			if (typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return Promise.resolve();
			const fd = new FormData();
			fd.append('action', action);
			if ( var_from_php.is_checkout ) {
				fd.append( 'include_checkout_order_review_items', '1' );
			}
			if (extra && typeof extra === 'object') {
				Object.keys(extra).forEach((k) => fd.append(k, extra[k]));
			}
			return fetch(var_from_php.ajax_url, {
				method: 'POST',
				credentials: 'same-origin',
				body: fd,
			})
				.then((r) => r.json())
				.then((data) => {
					if (data.success && data.data) {
						const inner = document.querySelector('.js-side-cart-inner');
						if (inner && data.data.html) inner.innerHTML = data.data.html;
						if (data.data.cart_count !== undefined) updateCartCountBadges(data.data.cart_count);
						if ( data.data.checkout_order_review_items_html !== undefined ) {
							const orderReviewItems = document.querySelector( '.js-checkout-order-review-cart-items' );
							if ( orderReviewItems ) {
								orderReviewItems.innerHTML = data.data.checkout_order_review_items_html;
							}
						}
						corppixApplyCheckoutSidebarFromAjaxData(data.data);
					} else if (data && data.success === false) {
						refreshSideCartInner();
					}
				})
				.catch(() => {});
		}

		function corppixFormatWcPrice(amount) {
			if (typeof var_from_php === 'undefined' || var_from_php.wc_price_decimals === undefined || var_from_php.wc_price_decimals === null) {
				return String(Math.round(amount * 100) / 100);
			}
			const decimals = parseInt(var_from_php.wc_price_decimals, 10);
			const n = Number.isNaN(decimals) ? 2 : decimals;
			const decSep = var_from_php.wc_price_decimal_sep != null ? var_from_php.wc_price_decimal_sep : '.';
			const thouSep = var_from_php.wc_price_thousand_sep != null ? var_from_php.wc_price_thousand_sep : '';
			const sym = var_from_php.wc_currency_symbol != null ? var_from_php.wc_currency_symbol : '';
			const pos = var_from_php.wc_currency_pos || 'right_space';
			const rounded = Math.round(amount * Math.pow(10, n)) / Math.pow(10, n);
			const negative = rounded < 0;
			const abs = Math.abs(rounded);
			const fixed = abs.toFixed(n);
			const parts = fixed.split('.');
			let intPart = parts[0];
			const decPart = parts[1];
			intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
			let numStr = decPart !== undefined ? intPart + decSep + decPart : intPart;
			if (negative) numStr = '-' + numStr;
			if (pos === 'left') return sym + numStr;
			if (pos === 'left_space') return sym + '\u00a0' + numStr;
			if (pos === 'right') return numStr + sym;
			return numStr + '\u00a0' + sym;
		}

		function corppixUpdateCartEditLinePrice(form) {
			if (!form) return;
			const priceEl = form.querySelector('.js-cart-edit-product-price');
			const qtyInput = form.querySelector('.js-cart-edit-qty-input');
			if (!priceEl || !qtyInput) return;
			const raw = priceEl.getAttribute('data-unit-price');
			if (raw === null || raw === '') return;
			const unit = parseFloat(String(raw), 10);
			if (Number.isNaN(unit)) return;
			const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
			const decimals = typeof var_from_php !== 'undefined' && var_from_php.wc_price_decimals !== undefined
				? parseInt(var_from_php.wc_price_decimals, 10)
				: 2;
			const n = Number.isNaN(decimals) ? 2 : decimals;
			const total = Math.round(unit * qty * Math.pow(10, n)) / Math.pow(10, n);
			priceEl.innerHTML = corppixFormatWcPrice(total);
		}

		document.addEventListener('keydown', (e) => {
			if (e.key !== 'Escape') return;
			const openPopup = document.querySelector('.js-popup.show');
			if (openPopup) {
				close_popups();
				return;
			}
			const root = document.querySelector('.js-side-cart');
			if (root && !root.classList.contains('hidden')) closeSideCart();
		});

		document.body.addEventListener('click', (e) => {
			const cartPopup = e.target.closest('.js-cart-item-edit-popup');
			if (cartPopup && cartPopup.classList.contains('show') && e.target === cartPopup) {
				close_popups();
				return;
			}
			const successPopup = e.target.closest('.js-main-form-success-popup');
			if (successPopup && successPopup.classList.contains('show') && e.target === successPopup) {
				close_popups();
			}
		});

		document.body.addEventListener('change', (e) => {
			const t = e.target;
			if (t.classList && t.classList.contains('js-cart-edit-personalization-toggle')) {
				const form = t.closest('.js-cart-edit-form');
				if (!form) return;
				const fields = form.querySelector('.js-cart-edit-personalization-fields');
				const warn = form.querySelector('.js-cart-edit-personalization-min-qty');
				const qtyInput = form.querySelector('.js-cart-edit-qty-input');
				const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
				const enabled = t.value === '1';
				if (fields) fields.classList.toggle('hidden', !enabled);
				const textErr = form.querySelector('.js-cart-edit-personalization-text-error');
				if (textErr) {
					textErr.classList.add('hidden');
					const defMsg = textErr.getAttribute('data-default-msg');
					if (defMsg != null) textErr.textContent = defMsg;
				}
				if (warn) {
					if (enabled && qty < 3) warn.classList.remove('hidden');
					else warn.classList.add('hidden');
				}
			}
			if (t.classList && t.classList.contains('js-cart-edit-personalization-file')) {
				const form = t.closest('.js-cart-edit-form');
				const nameEl = form ? form.querySelector('.js-cart-edit-file-name') : null;
				if (nameEl) {
					nameEl.textContent = t.files && t.files[0] ? t.files[0].name : '';
				}
			}
		});

		document.body.addEventListener('input', (e) => {
			const t = e.target;
			if (t.classList && t.classList.contains('js-cart-edit-personalization-text')) {
				const form = t.closest('.js-cart-edit-form');
				const err = form ? form.querySelector('.js-cart-edit-personalization-text-error') : null;
				if (err && String(t.value || '').trim()) {
					err.classList.add('hidden');
					const defMsg = err.getAttribute('data-default-msg');
					if (defMsg != null) err.textContent = defMsg;
				}
				return;
			}
			if (!t.classList || !t.classList.contains('js-cart-edit-qty-input')) return;
			const form = t.closest('.js-cart-edit-form');
			if (!form) return;
			corppixUpdateCartEditLinePrice(form);
			const warn = form.querySelector('.js-cart-edit-personalization-min-qty');
			const persOn = form.querySelector('.js-cart-edit-personalization-toggle:checked');
			if (!warn || !persOn || persOn.value !== '1') return;
			const qty = parseInt(t.value, 10) || 1;
			warn.classList.toggle('hidden', qty >= 3);
		});

		document.body.addEventListener('change', (e) => {
			const input = e.target.closest('.js-side-cart-qty-input');
			if (!input) return;
			const key = input.dataset.cartItemKey;
			const minQty = corppixGetSideCartLineMinQty(input);
			let qty = parseInt(input.value, 10);
			if (!key || Number.isNaN(qty) || qty < 1) {
				refreshSideCartInner();
				return;
			}
			if (qty < minQty) {
				qty = minQty;
				input.value = String(qty);
			}
			postSideCartAction('corppix_side_cart_update_qty', {
				cart_item_key: key,
				quantity: String(qty),
			});
		});

        initFakeSelects(); //innit custom select

		(function setupCheckoutConfirmOrderGate() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			function corppixUpdateCheckoutConfirmOrderButton() {
				const form = document.querySelector( 'form.checkout' );
				if ( ! form ) {
					return;
				}
				const btn = form.querySelector( '[data-role="confirm-order"]' );
				const c1 = form.querySelector( '[data-role="checkout-confirm-order-details"]' );
				const c2 = form.querySelector( '[data-role="checkout-confirm-privacy-policy"]' );
				if ( ! btn || ! c1 || ! c2 ) {
					return;
				}
				const ok = Boolean( c1.checked && c2.checked );
				btn.disabled = ! ok;
				btn.setAttribute( 'aria-disabled', ok ? 'false' : 'true' );
			}
			document.body.addEventListener( 'change', ( e ) => {
				const t = e.target;
				if ( ! t || ! t.getAttribute ) {
					return;
				}
				const role = t.getAttribute( 'data-role' );
				if ( role === 'checkout-confirm-order-details' || role === 'checkout-confirm-privacy-policy' ) {
					corppixUpdateCheckoutConfirmOrderButton();
				}
			} );
			if ( document.readyState === 'loading' ) {
				document.addEventListener( 'DOMContentLoaded', corppixUpdateCheckoutConfirmOrderButton );
			} else {
				corppixUpdateCheckoutConfirmOrderButton();
			}
			window.corppixRefreshCheckoutConfirmOrderGate = corppixUpdateCheckoutConfirmOrderButton;
		})();

		(function setupCheckoutCouponApplyGate() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			function corppixUpdateCheckoutCouponApplyButton() {
				const form = document.querySelector( 'form.checkout' );
				const inp = form ? form.querySelector( '.js-checkout-coupon-input' ) : document.querySelector( '.js-checkout-coupon-input' );
				const btn = form ? form.querySelector( '[data-role="apply-coupon"]' ) : document.querySelector( '[data-role="apply-coupon"]' );
				if ( ! inp || ! btn ) {
					return;
				}
				const has = String( inp.value || '' ).trim().length > 0;
				btn.disabled = ! has;
				btn.setAttribute( 'aria-disabled', has ? 'false' : 'true' );
			}
			document.body.addEventListener( 'input', ( e ) => {
				const t = e.target;
				if ( t && t.classList && t.classList.contains( 'js-checkout-coupon-input' ) ) {
					corppixUpdateCheckoutCouponApplyButton();
				}
			} );
			document.body.addEventListener( 'change', ( e ) => {
				const t = e.target;
				if ( t && t.classList && t.classList.contains( 'js-checkout-coupon-input' ) ) {
					corppixUpdateCheckoutCouponApplyButton();
				}
			} );
			if ( document.readyState === 'loading' ) {
				document.addEventListener( 'DOMContentLoaded', corppixUpdateCheckoutCouponApplyButton );
			} else {
				corppixUpdateCheckoutCouponApplyButton();
			}
			window.corppixRefreshCheckoutCouponApplyGate = corppixUpdateCheckoutCouponApplyButton;
		})();

		(function setupCheckoutNovaPoshta() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.ajax_url || ! var_from_php.is_checkout || ! var_from_php.np_ajax_nonce ) {
				return;
			}
			if ( typeof $ === 'undefined' || typeof $.fn.selectWoo !== 'function' ) {
				return;
			}

			const npNonce = var_from_php.np_ajax_nonce;
			const npIsUaCountry = ( countryCode ) => String( countryCode || '' ).toUpperCase() === 'UA';
			const npGetSelectedCountry = ( formEl ) => {
				const sel = formEl
					? formEl.querySelector( '[data-role="np-country-select"]' )
					: document.querySelector( '[data-role="np-country-select"]' );
				const v = sel ? String( sel.value || '' ).trim().toUpperCase() : 'UA';
				return v && /^[A-Z]{2}$/.test( v ) ? v : 'UA';
			};

			function npFetch( action, payload, fetchOpts ) {
				const fd = new FormData();
				fd.append( 'action', action );
				fd.append( 'nonce', npNonce );
				if ( payload && typeof payload === 'object' ) {
					Object.keys( payload ).forEach( ( k ) => fd.append( k, payload[ k ] ) );
				}
				const init = {
					method: 'POST',
					credentials: 'same-origin',
					body: fd,
				};
				if ( fetchOpts && fetchOpts.signal ) {
					init.signal = fetchOpts.signal;
				}
				return fetch( var_from_php.ajax_url, init ).then( ( r ) => r.json() );
			}

			function npPlaceholderFromSelect( sel ) {
				return ( sel && sel.dataset && sel.dataset.npPlaceholder ) ? String( sel.dataset.npPlaceholder ) : '';
			}

			function npIsNpAddressDelivery( value ) {
				return value === 'post-office' || value === 'parcel-machine';
			}

			function npAddressRowNeedsVisible( value ) {
				return npIsNpAddressDelivery( value ) || value === 'courier-city';
			}

			function npToggleNpCourierBlocks( formEl, deliveryValue ) {
				if ( ! formEl ) {
					return;
				}
				const npBlock = formEl.querySelector( '[data-role="np-fields-np"]' );
				const crBlock = formEl.querySelector( '[data-role="courier-address-fields"]' );
				if ( ! npBlock || ! crBlock ) {
					return;
				}
				if ( npIsNpAddressDelivery( deliveryValue ) ) {
					npBlock.classList.remove( 'hidden' );
					crBlock.classList.add( 'hidden' );
				} else if ( deliveryValue === 'courier-city' ) {
					npBlock.classList.add( 'hidden' );
					crBlock.classList.remove( 'hidden' );
				} else {
					npBlock.classList.add( 'hidden' );
					crBlock.classList.add( 'hidden' );
				}
			}

			function npGetNpPointType( formEl ) {
				if ( ! formEl ) {
					return 'warehouse';
				}
				const r = formEl.querySelector( 'input[name="delivery_type"]:checked' );
				return r && r.value === 'parcel-machine' ? 'postomat' : 'warehouse';
			}

			function npSetWarehouseEmptyNotice( formEl, visible, pointType ) {
				const row = formEl ? formEl.querySelector( '[data-role="np-address-fields"]' ) : null;
				const el = formEl ? formEl.querySelector( '[data-role="np-warehouse-empty"]' ) : null;
				if ( ! el ) {
					return;
				}
				if ( visible && row ) {
					const isPost = pointType === 'postomat';
					const msg = isPost
						? String( row.dataset.npEmptyPostomatMsg || '' ).trim()
						: String( row.dataset.npEmptyWarehouseMsg || '' ).trim();
					el.textContent =
						msg ||
						( isPost ? 'У цьому місті немає поштоматів Нової пошти.' : 'У цьому місті немає відділень Нової пошти.' );
				}
				el.classList.toggle( 'hidden', ! visible );
			}

			function npSetWarehouseNotice( formEl, visible ) {
				const el = formEl ? formEl.querySelector( '[data-role="np-warehouse-notice"]' ) : null;
				if ( el ) {
					el.classList.toggle( 'hidden', ! visible );
				}
				if ( visible && formEl ) {
					npSetWarehouseEmptyNotice( formEl, false );
				}
			}

			function npSyncWarehousePlaceholder( formEl ) {
				const row = formEl ? formEl.querySelector( '[data-role="np-address-fields"]' ) : null;
				const wh = formEl ? formEl.querySelector( '[data-role="np-warehouse-select"]' ) : null;
				if ( ! row || ! wh ) {
					return;
				}
				const ph =
					npGetNpPointType( formEl ) === 'postomat'
						? String( row.dataset.phPostomat || '' ).trim()
						: String( row.dataset.phWarehouse || '' ).trim();
				if ( ! ph ) {
					return;
				}
				wh.dataset.npPlaceholder = ph;
				const opt0 = wh.querySelector( 'option[value=""]' );
				if ( opt0 ) {
					opt0.textContent = ph;
				}
			}

			function npResetSelectOptions( sel, disableAfter ) {
				if ( ! sel ) {
					return;
				}
				const ph = npPlaceholderFromSelect( sel );
				sel.innerHTML = '';
				const o0 = document.createElement( 'option' );
				o0.value = '';
				o0.textContent = ph;
				sel.appendChild( o0 );
				sel.value = '';
				if ( typeof disableAfter === 'boolean' ) {
					sel.disabled = disableAfter;
				}
			}

			function npDestroyCitySelectWoo( citySel ) {
				if ( ! citySel || citySel.dataset.npSelectWooReady !== '1' ) {
					return;
				}
				if ( citySel._npWhSch ) {
					window.clearTimeout( citySel._npWhSch );
					delete citySel._npWhSch;
				}
				if ( citySel._npWhRetrySch ) {
					window.clearTimeout( citySel._npWhRetrySch );
					delete citySel._npWhRetrySch;
				}
				delete citySel._npPendingCityRef;
				if ( citySel._npWhAbortCtl ) {
					try {
						citySel._npWhAbortCtl.abort();
					} catch ( errAbort ) {
					}
					delete citySel._npWhAbortCtl;
				}
				delete citySel._npWhLoadSeq;
				const $el = $( citySel );
				$el.off( '.npwh' );
				if ( $el.data( 'select2' ) ) {
					$el.selectWoo( 'destroy' );
				}
				delete citySel.dataset.npSelectWooReady;
			}

			function npResolveCityRef( $city ) {
				let ref = ( $city.val() || '' ).toString().trim();
				if ( ref ) {
					return ref;
				}
				try {
					const picked = $city.selectWoo( 'data' );
					if ( ! picked ) {
						return '';
					}
					if ( Array.isArray( picked ) ) {
						if ( picked.length && picked[ 0 ] && picked[ 0 ].id != null ) {
							ref = String( picked[ 0 ].id ).trim();
						}
					} else if ( typeof picked === 'object' && picked.id != null ) {
						ref = String( picked.id ).trim();
					}
					return ref || '';
				} catch ( err ) {
				}
				return '';
			}

			function npDestroyWarehouseSelectWoo( whSel ) {
				if ( ! whSel || whSel.dataset.npWarehouseSw !== '1' ) {
					return;
				}
				const $wh = $( whSel );
				$wh.off( '.npsum' );
				if ( $wh.data( 'select2' ) ) {
					$wh.selectWoo( 'destroy' );
				}
				delete whSel.dataset.npWarehouseSw;
			}

			function npBindWarehouseSummarySync( whSel ) {
				if ( ! whSel || typeof window.jQuery === 'undefined' ) {
					return;
				}
				const $wh = window.jQuery( whSel );
				$wh.off( '.npsum' );
				$wh.on( 'select2:select.npsum', function ( evt ) {
					const pickedText =
						evt && evt.params && evt.params.data && evt.params.data.text != null
							? String( evt.params.data.text ).trim()
							: '';
					checkoutSyncDeliveryWarehouseSummary( whSel, pickedText || undefined );
				} );
				$wh.on( 'change.npsum', function () {
					window.setTimeout( function () {
						checkoutSyncDeliveryWarehouseSummary( whSel );
					}, 0 );
				} );
			}

			function npInitWarehouseSelectWooPlaceholder( whSel ) {
				if ( ! whSel ) {
					return;
				}
				npDestroyWarehouseSelectWoo( whSel );
				const $wh = $( whSel );
				const ph = npPlaceholderFromSelect( whSel );
				$wh.prop( 'disabled', true );
				$wh.selectWoo( {
					width: '100%',
					disabled: true,
					allowClear: false,
					placeholder: ph,
					minimumResultsForSearch: Infinity,
					dropdownCssClass: 'corppix-np-city-dropdown',
					dropdownParent: $( document.body ),
					language: {
						noResults() {
							return t( 'np_city_no_results', 'Нічого не знайдено' );
						},
						searching() {
							return t( 'np_city_searching', 'Пошук…' );
						},
					},
				} );
				whSel.dataset.npWarehouseSw = '1';
				checkoutSyncDeliveryWarehouseSummary( whSel );
			}

			function npInitWarehouseSelectWoo( whSel ) {
				if ( ! whSel || whSel.disabled || whSel.options.length <= 1 ) {
					return;
				}
				npDestroyWarehouseSelectWoo( whSel );
				const $wh = $( whSel );
				const ph = npPlaceholderFromSelect( whSel );
				$wh.prop( 'disabled', false );
				$wh.selectWoo( {
					width: '100%',
					allowClear: false,
					placeholder: ph,
					minimumResultsForSearch: 0,
					dropdownCssClass: 'corppix-np-city-dropdown',
					dropdownParent: $( document.body ),
					language: {
						noResults() {
							return t( 'np_city_no_results', 'Нічого не знайдено' );
						},
						searching() {
							return t( 'np_city_searching', 'Пошук…' );
						},
					},
				} );
				whSel.dataset.npWarehouseSw = '1';
				npBindWarehouseSummarySync( whSel );
				checkoutSyncDeliveryWarehouseSummary( whSel );
			}

			function npEnsureNpFieldLoader( wrap ) {
				if ( ! wrap ) {
					return null;
				}
				let el = wrap.querySelector( '.js-np-field-loader' );
				if ( ! el ) {
					el = document.createElement( 'div' );
					el.className =
						'js-np-field-loader pointer-events-none absolute inset-0 z-[25] hidden items-center justify-center bg-[#fafafa]/[0.92]';
					el.setAttribute( 'role', 'status' );
					el.setAttribute( 'aria-live', 'polite' );
					el.setAttribute( 'aria-label', t( 'np_loading', 'Завантаження' ) );
					el.innerHTML =
						'<span class="inline-block h-[26px] w-[26px] rounded-full border-2 border-solid border-[#D9D9D9] border-t-[#B6F000] animate-spin" aria-hidden="true"></span>';
					wrap.appendChild( el );
				}
				el.classList.remove( 'hidden' );
				el.classList.add( 'flex' );
				return el;
			}

			function npHideNpFieldLoader( wrap ) {
				if ( ! wrap ) {
					return;
				}
				const el = wrap.querySelector( '.js-np-field-loader' );
				if ( el ) {
					el.classList.add( 'hidden' );
					el.classList.remove( 'flex' );
				}
			}

			function npShowNpWarehousesLoaders( formEl ) {
				if ( ! formEl ) {
					return;
				}
				const whWrap = formEl.querySelector( '[data-role="np-warehouse-wrap"]' );
				npEnsureNpFieldLoader( whWrap );
			}

			function npHideNpWarehousesLoaders( formEl ) {
				if ( ! formEl ) {
					return;
				}
				npHideNpFieldLoader( formEl.querySelector( '[data-role="np-warehouse-wrap"]' ) );
			}

			function npLoadWarehousesForCityRef( citySel, cityRef ) {
				const formEl = citySel.closest( 'form.checkout' );
				const wh = formEl ? formEl.querySelector( '[data-role="np-warehouse-select"]' ) : null;
				if ( ! wh || ! cityRef ) {
					return;
				}
				if ( ! citySel._npWhLoadSeq ) {
					citySel._npWhLoadSeq = 0;
				}
				citySel._npWhLoadSeq += 1;
				const seq = citySel._npWhLoadSeq;
				if ( citySel._npWhAbortCtl ) {
					try {
						citySel._npWhAbortCtl.abort();
					} catch ( errAbort ) {
					}
				}
				citySel._npWhAbortCtl = new AbortController();
				const { signal } = citySel._npWhAbortCtl;

				npShowNpWarehousesLoaders( formEl );
				npSetWarehouseNotice( formEl, false );
				npSetWarehouseEmptyNotice( formEl, false );
				npDestroyWarehouseSelectWoo( wh );
				npResetSelectOptions( wh, true );
				wh.disabled = true;
				checkoutSyncDeliveryWarehouseSummary( wh );
				npFetch(
					'corppix_np_get_warehouses',
					{
						city_ref: cityRef,
						np_point_type: npGetNpPointType( formEl ),
					},
					{ signal }
				)
					.then( ( data ) => {
						if ( seq !== citySel._npWhLoadSeq ) {
							return;
						}
						npResetSelectOptions( wh, true );
						if ( ! data.success || ! data.data ) {
							npSetWarehouseNotice( formEl, true );
							npInitWarehouseSelectWooPlaceholder( wh );
							return;
						}
						const items = data.data.items || [];
						const seenRefs = new Set();
						items.forEach( ( item ) => {
							const ref = item.ref ? String( item.ref ).trim() : '';
							if ( ! ref || seenRefs.has( ref ) ) {
								return;
							}
							seenRefs.add( ref );
							const op = document.createElement( 'option' );
							op.value = ref;
							op.textContent = item.label || ref;
							wh.appendChild( op );
						} );
						wh.disabled = wh.options.length <= 1;
						if ( ! wh.disabled ) {
							npSetWarehouseNotice( formEl, false );
							npSetWarehouseEmptyNotice( formEl, false );
							npInitWarehouseSelectWoo( wh );
						} else {
							npSetWarehouseNotice( formEl, false );
							npSetWarehouseEmptyNotice( formEl, true, npGetNpPointType( formEl ) );
							npInitWarehouseSelectWooPlaceholder( wh );
						}
					} )
					.catch( ( err ) => {
						if ( seq !== citySel._npWhLoadSeq || ( err && err.name === 'AbortError' ) ) {
							return;
						}
						npSetWarehouseEmptyNotice( formEl, false );
						npSetWarehouseNotice( formEl, true );
						wh.disabled = false;
						npInitWarehouseSelectWooPlaceholder( wh );
					} )
					.finally( () => {
						if ( seq !== citySel._npWhLoadSeq ) {
							return;
						}
						npHideNpWarehousesLoaders( formEl );
					} );
			}

			function npLoadDivisionsForSettlementId( citySel, countryCode, settlementId ) {
				const formEl = citySel.closest( 'form.checkout' );
				const wh = formEl ? formEl.querySelector( '[data-role="np-warehouse-select"]' ) : null;
				if ( ! wh || ! settlementId ) {
					return;
				}

				if ( ! citySel._npWhLoadSeq ) {
					citySel._npWhLoadSeq = 0;
				}
				citySel._npWhLoadSeq += 1;
				const seq = citySel._npWhLoadSeq;

				if ( citySel._npWhAbortCtl ) {
					try {
						citySel._npWhAbortCtl.abort();
					} catch ( errAbort ) {
					}
				}
				citySel._npWhAbortCtl = new AbortController();
				const { signal } = citySel._npWhAbortCtl;

				npShowNpWarehousesLoaders( formEl );
				npSetWarehouseNotice( formEl, false );
				npSetWarehouseEmptyNotice( formEl, false );
				npDestroyWarehouseSelectWoo( wh );
				npResetSelectOptions( wh, true );
				wh.disabled = true;
				checkoutSyncDeliveryWarehouseSummary( wh );

				npFetch(
					'corppix_novapost_get_divisions',
					{
						country: countryCode,
						settlement_id: settlementId,
						np_point_type: npGetNpPointType( formEl ),
					},
					{ signal }
				)
					.then( ( data ) => {
						if ( seq !== citySel._npWhLoadSeq ) {
							return;
						}
						npResetSelectOptions( wh, true );
						if ( ! data.success || ! data.data ) {
							npSetWarehouseNotice( formEl, true );
							npInitWarehouseSelectWooPlaceholder( wh );
							return;
						}
						const items = data.data.items || [];
						const seenRefs = new Set();
						items.forEach( ( item ) => {
							const ref = item.ref ? String( item.ref ).trim() : '';
							if ( ! ref || seenRefs.has( ref ) ) {
								return;
							}
							seenRefs.add( ref );
							const op = document.createElement( 'option' );
							op.value = ref;
							op.textContent = item.label || ref;
							wh.appendChild( op );
						} );
						wh.disabled = wh.options.length <= 1;
						if ( ! wh.disabled ) {
							npSetWarehouseNotice( formEl, false );
							npSetWarehouseEmptyNotice( formEl, false );
							npInitWarehouseSelectWoo( wh );
						} else {
							npSetWarehouseNotice( formEl, false );
							npSetWarehouseEmptyNotice( formEl, true, npGetNpPointType( formEl ) );
							npInitWarehouseSelectWooPlaceholder( wh );
						}
					} )
					.catch( ( err ) => {
						if ( seq !== citySel._npWhLoadSeq || ( err && err.name === 'AbortError' ) ) {
							return;
						}
						npSetWarehouseEmptyNotice( formEl, false );
						npSetWarehouseNotice( formEl, true );
						wh.disabled = false;
						npInitWarehouseSelectWooPlaceholder( wh );
					} )
					.finally( () => {
						if ( seq !== citySel._npWhLoadSeq ) {
							return;
						}
						npHideNpWarehousesLoaders( formEl );
					} );
			}

			function npBindCityWarehouseLoad( citySel ) {
				const $city = $( citySel );
				$city.off( '.npwh' );
				const runWarehouseLoad = function () {
					if ( citySel._npWhRetrySch ) {
						window.clearTimeout( citySel._npWhRetrySch );
						delete citySel._npWhRetrySch;
					}
					const pending = citySel._npPendingCityRef
						? String( citySel._npPendingCityRef ).trim()
						: '';
					if ( pending ) {
						delete citySel._npPendingCityRef;
					}
					const ref = pending || npResolveCityRef( $city );
					if ( ! ref ) {
						citySel._npWhRetrySch = window.setTimeout( function () {
							citySel._npWhRetrySch = null;
							const ref2 = npResolveCityRef( $city );
							if ( ref2 ) {
								npLoadWarehousesForCityRef( citySel, ref2 );
							}
						}, 220 );
						return;
					}
					const formEl = citySel.closest( 'form.checkout' ) || document.querySelector( 'form.checkout' );
					const cc = npGetSelectedCountry( formEl );
					if ( npIsUaCountry( cc ) ) {
						npLoadWarehousesForCityRef( citySel, ref );
					} else {
						npLoadDivisionsForSettlementId( citySel, cc, ref );
					}
				};
				const scheduleWarehouseLoad = function () {
					if ( citySel._npWhSch ) {
						window.clearTimeout( citySel._npWhSch );
					}
					citySel._npWhSch = window.setTimeout( function () {
						citySel._npWhSch = null;
						runWarehouseLoad();
					}, 200 );
				};
				$city.on( 'select2:select.npwh', function ( evt ) {
					if ( evt && evt.params && evt.params.data && evt.params.data.id != null ) {
						citySel._npPendingCityRef = String( evt.params.data.id ).trim();
					}
					const pickedText =
						evt && evt.params && evt.params.data && evt.params.data.text != null
							? String( evt.params.data.text ).trim()
							: '';
					checkoutSyncDeliveryCitySummary( citySel, pickedText || undefined );
					scheduleWarehouseLoad();
				} );
				$city.on( 'change.npwh', function () {
					scheduleWarehouseLoad();
					window.setTimeout( function () {
						checkoutSyncDeliveryCitySummary( citySel );
					}, 0 );
				} );
			}

			function npInitCitySelectWoo( citySel ) {
				if ( ! citySel || citySel.dataset.npSelectWooReady === '1' ) {
					return;
				}
				const $el = $( citySel );
				const ph = npPlaceholderFromSelect( citySel );

				$el.selectWoo( {
					width: '100%',
					allowClear: false,
					placeholder: ph,
					dropdownCssClass: 'corppix-np-city-dropdown',
					// Body: avoids wrong offset when ancestors use transform / overflow (checkout layout).
					dropdownParent: $( document.body ),
					minimumInputLength: 2,
					language: {
						noResults() {
							return t( 'np_city_no_results', 'Нічого не знайдено' );
						},
						searching() {
							return t( 'np_city_searching', 'Пошук…' );
						},
						inputTooShort() {
							return t( 'np_city_input_too_short', 'Введіть мінімум 2 символи для пошуку міста' );
						},
					},
					ajax: {
						url: var_from_php.ajax_url,
						type: 'POST',
						dataType: 'json',
						delay: 300,
						data( params ) {
							const formEl = citySel.closest( 'form.checkout' ) || document.querySelector( 'form.checkout' );
							const cc = npGetSelectedCountry( formEl );
							if ( ! npIsUaCountry( cc ) ) {
								return {
									action: 'corppix_novapost_search_settlements',
									nonce: npNonce,
									country: cc,
									search: params.term || '',
								};
							}
							return {
								action: 'corppix_np_search_cities',
								nonce: npNonce,
								search: params.term || '',
							};
						},
						processResults( response ) {
							if ( ! response || ! response.success || ! response.data || ! Array.isArray( response.data.items ) ) {
								return { results: [], pagination: { more: false } };
							}
							return {
								results: response.data.items.map( ( item ) => ( {
									id: item.ref,
									text: item.label,
								} ) ),
								pagination: { more: false },
							};
						},
						cache: true,
					},
				} );

				citySel.dataset.npSelectWooReady = '1';
				npBindCityWarehouseLoad( citySel );
			}

			const checkoutForm = document.querySelector( 'form.checkout' );
			const npRow = document.querySelector( '[data-role="np-address-fields"]' );
			if ( checkoutForm && npRow ) {
				const checkedDt = checkoutForm.querySelector( 'input[name="delivery_type"]:checked' );
				if ( checkedDt && ! npAddressRowNeedsVisible( checkedDt.value ) ) {
					npRow.classList.add( 'hidden' );
				}
				npToggleNpCourierBlocks( checkoutForm, checkedDt ? checkedDt.value : 'post-office' );
			}

			window.corppixNpOnDeliveryTypeChange = function( e ) {
				const t = e.target;
				if ( ! t || ! t.matches || ! t.matches( 'input[name="delivery_type"]' ) ) {
					return;
				}
				const row = document.querySelector( '[data-role="np-address-fields"]' );
				if ( ! row ) {
					return;
				}
				const formEl = t.closest( 'form.checkout' );
				const citySel = formEl ? formEl.querySelector( '[data-role="np-city-select"]' ) : null;
				const whSel = formEl ? formEl.querySelector( '[data-role="np-warehouse-select"]' ) : null;
				const deliveryVal = t.value;
				const countryCode = npGetSelectedCountry( formEl );

				const clearCourierFields = () => {
					if ( ! formEl ) {
						return;
					}
					const inputs = formEl.querySelectorAll(
						'[data-role="courier-city-input"], [data-role="courier-street-input"], [data-role="courier-house-input"], [data-role="courier-apartment-input"]'
					);
					inputs.forEach( ( inp ) => {
						if ( inp && ! inp.disabled ) {
							inp.value = '';
						}
					} );
				};

				if ( npAddressRowNeedsVisible( deliveryVal ) ) {
					row.classList.remove( 'hidden' );
					npToggleNpCourierBlocks( formEl, deliveryVal );

					if ( npIsNpAddressDelivery( deliveryVal ) ) {
						// Leaving courier mode -> clear courier fields.
						clearCourierFields();

						if ( formEl ) {
							npSyncWarehousePlaceholder( formEl );
							npSetWarehouseNotice( formEl, false );
							npSetWarehouseEmptyNotice( formEl, false );
						}
						if ( whSel ) {
							npDestroyWarehouseSelectWoo( whSel );
							npResetSelectOptions( whSel, true );
							checkoutSyncDeliveryWarehouseSummary( whSel, '' );
							whSel.disabled = true;
							npInitWarehouseSelectWooPlaceholder( whSel );
						}
						if ( citySel ) {
							if ( citySel.dataset.npSelectWooReady !== '1' ) {
								npDestroyCitySelectWoo( citySel );
								npResetSelectOptions( citySel, false );
								checkoutSyncDeliveryCitySummary( citySel, '' );
								npInitCitySelectWoo( citySel );
							} else {
								const ref = npResolveCityRef( $( citySel ) );
								if ( ref ) {
									if ( npIsUaCountry( countryCode ) ) {
										npLoadWarehousesForCityRef( citySel, ref );
									} else {
										npLoadDivisionsForSettlementId( citySel, countryCode, ref );
									}
								} else if ( whSel ) {
									npDestroyWarehouseSelectWoo( whSel );
									npResetSelectOptions( whSel, true );
									checkoutSyncDeliveryWarehouseSummary( whSel, '' );
									npInitWarehouseSelectWooPlaceholder( whSel );
								}
							}
						}
					} else if ( deliveryVal === 'courier-city' ) {
						if ( formEl ) {
							npSetWarehouseNotice( formEl, false );
							npSetWarehouseEmptyNotice( formEl, false );
						}
						if ( whSel ) {
							npDestroyWarehouseSelectWoo( whSel );
							npResetSelectOptions( whSel, true );
							checkoutSyncDeliveryWarehouseSummary( whSel, '' );
						}
						if ( citySel ) {
							npDestroyCitySelectWoo( citySel );
							npResetSelectOptions( citySel, false );
							checkoutSyncDeliveryCitySummary( citySel, '' );
						}
					}
				} else {
					row.classList.add( 'hidden' );
					npToggleNpCourierBlocks( formEl, deliveryVal );
					// Leaving both NP and courier -> clear courier fields.
					clearCourierFields();
					if ( formEl ) {
						npSetWarehouseNotice( formEl, false );
						npSetWarehouseEmptyNotice( formEl, false );
					}
					if ( whSel ) {
						npDestroyWarehouseSelectWoo( whSel );
						npResetSelectOptions( whSel, true );
						checkoutSyncDeliveryWarehouseSummary( whSel, '' );
					}
					if ( citySel ) {
						npDestroyCitySelectWoo( citySel );
						npResetSelectOptions( citySel, false );
						checkoutSyncDeliveryCitySummary( citySel, '' );
					}
				}
			};

			const cityInit = document.querySelector( '[data-role="np-city-select"]' );
			const whInit = document.querySelector( '[data-role="np-warehouse-select"]' );
			if ( npRow && checkoutForm && ! npRow.classList.contains( 'hidden' ) ) {
				const dtInit = checkoutForm.querySelector( 'input[name="delivery_type"]:checked' );
				npToggleNpCourierBlocks( checkoutForm, dtInit ? dtInit.value : 'post-office' );
				if ( dtInit && npIsNpAddressDelivery( dtInit.value ) ) {
					npSyncWarehousePlaceholder( checkoutForm );
					if ( whInit ) {
						npResetSelectOptions( whInit, true );
						npInitWarehouseSelectWooPlaceholder( whInit );
					}
					if ( cityInit ) {
						npInitCitySelectWoo( cityInit );
					}
				}
			}

			function npResetNpAddressOnCountryChange( formEl ) {
				const citySel = formEl ? formEl.querySelector( '[data-role="np-city-select"]' ) : null;
				const whSel = formEl ? formEl.querySelector( '[data-role="np-warehouse-select"]' ) : null;
				if ( citySel ) {
					npDestroyCitySelectWoo( citySel );
					npResetSelectOptions( citySel, false );
					checkoutSyncDeliveryCitySummary( citySel, '' );
					npInitCitySelectWoo( citySel );
				}
				if ( whSel ) {
					npDestroyWarehouseSelectWoo( whSel );
					npResetSelectOptions( whSel, true );
					checkoutSyncDeliveryWarehouseSummary( whSel, '' );
					npInitWarehouseSelectWooPlaceholder( whSel );
				}
				npSetWarehouseNotice( formEl, false );
				npSetWarehouseEmptyNotice( formEl, false );
			}

			function npSyncUaDeliveryEtaBadges( formEl ) {
				const isUa = npIsUaCountry( npGetSelectedCountry( formEl ) );
				document.querySelectorAll( '[data-role="np-ua-delivery-eta"]' ).forEach( ( el ) => {
					el.classList.toggle( 'hidden', ! isUa );
				} );
			}

			npSyncUaDeliveryEtaBadges( checkoutForm );

			document.body.addEventListener( 'change', ( e ) => {
				const t = e.target;
				if ( ! t || ! t.getAttribute ) {
					return;
				}
				if ( t.getAttribute( 'data-role' ) !== 'np-country-select' ) {
					return;
				}
				const formEl = t.closest( 'form.checkout' ) || document.querySelector( 'form.checkout' );
				if ( ! formEl ) {
					return;
				}
				npResetNpAddressOnCountryChange( formEl );
				npSyncUaDeliveryEtaBadges( formEl );
			} );
		})();

		(function setupCheckoutRecipientOther() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			function syncRecipientOtherFields() {
				const formEl = document.querySelector( 'form.checkout' );
				if ( ! formEl ) {
					return;
				}
				const wrap = formEl.querySelector( '[data-role="recipient-other-fields"]' );
				const nameIn = formEl.querySelector( '[data-role="recipient-other-name"]' );
				const phoneIn = formEl.querySelector( '[data-role="recipient-other-phone"]' );
				if ( ! wrap || ! nameIn || ! phoneIn ) {
					return;
				}
				const r = formEl.querySelector( 'input[name="recipient_type"]:checked' );
				const show = r && r.value === 'other';
				wrap.classList.toggle( 'hidden', ! show );
				[ nameIn, phoneIn ].forEach( ( inp ) => {
					if ( show ) {
						inp.disabled = false;
						inp.required = true;
					} else {
						inp.required = false;
						inp.disabled = true;
						inp.value = '';
					}
				} );
			}
			window.corppixCheckoutSyncRecipientOtherFields = syncRecipientOtherFields;
			syncRecipientOtherFields();
		})();

		(function initCheckoutDeliverySummaryTitle() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}
			const formEl = document.querySelector( 'form.checkout' );
			const checked = formEl ? formEl.querySelector( 'input[name="delivery_type"]:checked' ) : null;
			const out = document.querySelector( '.js-checkout-summary-delivery-method' );
			if ( checked && out ) {
				const t = checked.getAttribute( 'data-title' );
				if ( t ) {
					out.textContent = t;
				}
			}
			const citySel = formEl ? formEl.querySelector( '[data-role="np-city-select"]' ) : null;
			checkoutSyncDeliveryCitySummary( citySel );
			const whSel = formEl ? formEl.querySelector( '[data-role="np-warehouse-select"]' ) : null;
			checkoutSyncDeliveryWarehouseSummary( whSel );
			const dtForLabel = formEl ? formEl.querySelector( 'input[name="delivery_type"]:checked' ) : null;
			const dtVal = dtForLabel ? dtForLabel.value : 'post-office';
			checkoutSyncNpPointSummaryLabel( dtVal );
			checkoutSyncDeliverySummaryAddressRows( dtVal );
			if ( dtVal === 'courier-city' ) {
				checkoutSyncAllCourierSummaryFields( formEl );
			}
			checkoutSyncPaymentMethodSummary();
		})();

		(function setupCheckoutStep1Validation() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
				return;
			}

			function valMsg( key, fallback ) {
				const o = var_from_php.checkout_val_msg;
				return o && o[ key ] ? o[ key ] : fallback;
			}

			function ensurePlaceholderStar( str ) {
				const t = String( str || '' ).trim();
				if ( ! t || t.endsWith( '*' ) ) {
					return str || '';
				}
				return t + '*';
			}

			function applyMandatoryPlaceholdersToForm( formEl ) {
				if ( ! formEl ) {
					return;
				}
				const mandatoryInputs = formEl.querySelectorAll(
					'[name="contact-name"], [name="contact-phone"], [name="contact-email"], [data-role="recipient-other-name"], [data-role="recipient-other-phone"], [data-role="courier-city-input"], [data-role="courier-street-input"], [data-role="courier-house-input"], [data-role="courier-apartment-input"]'
				);
				mandatoryInputs.forEach( ( el ) => {
					if ( el.disabled ) {
						return;
					}
					el.placeholder = ensurePlaceholderStar( el.placeholder );
				} );
				const citySel = formEl.querySelector( '[data-role="np-city-select"]' );
				if ( citySel && citySel.dataset.npPlaceholder ) {
					citySel.dataset.npPlaceholder = ensurePlaceholderStar( citySel.dataset.npPlaceholder );
					const o0 = citySel.querySelector( 'option[value=""]' );
					if ( o0 ) {
						o0.textContent = citySel.dataset.npPlaceholder;
					}
				}
				const whSel = formEl.querySelector( '[data-role="np-warehouse-select"]' );
				if ( whSel && whSel.dataset.npPlaceholder ) {
					whSel.dataset.npPlaceholder = ensurePlaceholderStar( whSel.dataset.npPlaceholder );
					const w0 = whSel.querySelector( 'option[value=""]' );
					if ( w0 ) {
						w0.textContent = whSel.dataset.npPlaceholder;
					}
				}
			}

			function emailLooksValid( v ) {
				return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( String( v || '' ).trim() );
			}

			function phoneLooksValid( v ) {
				const d = String( v || '' ).replace( /\D/g, '' );
				return d.length >= 9;
			}

			function checkoutGetNpCityRef( formEl ) {
				const citySel = formEl.querySelector( '[data-role="np-city-select"]' );
				if ( ! citySel ) {
					return '';
				}
				let ref = String( citySel.value || '' ).trim();
				if ( ref ) {
					return ref;
				}
				if ( typeof $ !== 'undefined' && typeof $.fn.selectWoo === 'function' && citySel.dataset.npSelectWooReady === '1' ) {
					try {
						const picked = $( citySel ).selectWoo( 'data' );
						if ( picked ) {
							if ( Array.isArray( picked ) && picked.length && picked[ 0 ] && picked[ 0 ].id != null ) {
								ref = String( picked[ 0 ].id ).trim();
							} else if ( typeof picked === 'object' && picked.id != null ) {
								ref = String( picked.id ).trim();
							}
						}
					} catch ( err ) {
					}
				}
				return ref || '';
			}

			function clearInvalidMarks( formEl ) {
				formEl.querySelectorAll( '.js-checkout-invalid' ).forEach( ( n ) => n.classList.remove( 'js-checkout-invalid' ) );
			}

			function markInvalid( el, invalid ) {
				if ( ! el ) {
					return;
				}
				el.classList.toggle( 'js-checkout-invalid', !! invalid );
			}

			function showStep1Errors( formEl, messages ) {
				const box = formEl.querySelector( '[data-role="checkout-step1-errors"]' );
				if ( box ) {
					box.textContent = messages.join( ' ' );
					box.classList.remove( 'hidden' );
				}
			}

			function clearStep1Errors( formEl ) {
				const box = formEl.querySelector( '[data-role="checkout-step1-errors"]' );
				if ( box ) {
					box.textContent = '';
					box.classList.add( 'hidden' );
				}
			}

			const checkoutStepIds = [ 'contact-fields', 'payment-method', 'confirmation-order' ];

			function checkoutSetActiveStep( formEl, stepId ) {
				if ( ! formEl || checkoutStepIds.indexOf( stepId ) === -1 ) {
					return;
				}
				formEl.dataset.checkoutActiveStep = stepId;

				const headerMap = {
					'contact-fields': '.js-contact-fields',
					'payment-method': '.js-payment-method',
					'confirmation-order': '.js-confirmation-order',
				};
				Object.keys( headerMap ).forEach( ( id ) => {
					const h = formEl.querySelector( headerMap[ id ] );
					if ( h ) {
						h.classList.toggle( 'hidden', id !== stepId );
					}
				} );

				checkoutStepIds.forEach( ( id ) => {
					const panel = document.getElementById( id );
					if ( panel ) {
						panel.classList.toggle( 'hidden', id !== stepId );
					}
				} );

				formEl.querySelectorAll( '.checkout-step-nav' ).forEach( ( nav ) => {
					const tab = nav.getAttribute( 'data-tab' );
					nav.classList.toggle( 'active', tab === stepId );
				} );
			}

			function validateCheckoutStep1( formEl ) {
				const errors = [];
				let firstFocus = null;
				const pushErr = function ( message, el ) {
					errors.push( message );
					if ( el && ! firstFocus ) {
						firstFocus = el;
					}
				};

				clearInvalidMarks( formEl );
				clearStep1Errors( formEl );

				const nameIn = formEl.querySelector( '[name="contact-name"]' );
				const phoneIn = formEl.querySelector( '[name="contact-phone"]' );
				const emailIn = formEl.querySelector( '[name="contact-email"]' );

				if ( ! String( nameIn && nameIn.value ? nameIn.value : '' ).trim() ) {
					markInvalid( nameIn, true );
					pushErr( valMsg( 'contact_name', 'Вкажіть імʼя та прізвище.' ), nameIn );
				}
				const phoneRaw = String( phoneIn && phoneIn.value ? phoneIn.value : '' ).trim();
				if ( ! phoneRaw ) {
					markInvalid( phoneIn, true );
					pushErr( valMsg( 'contact_phone', 'Вкажіть номер телефону.' ), phoneIn );
				} else if ( ! phoneLooksValid( phoneRaw ) ) {
					markInvalid( phoneIn, true );
					pushErr( valMsg( 'contact_phone_format', 'Номер телефону виглядає некоректним.' ), phoneIn );
				}
				const emailRaw = String( emailIn && emailIn.value ? emailIn.value : '' ).trim();
				if ( ! emailRaw ) {
					markInvalid( emailIn, true );
					pushErr( valMsg( 'contact_email', 'Вкажіть e-mail.' ), emailIn );
				} else if ( ! emailLooksValid( emailRaw ) ) {
					markInvalid( emailIn, true );
					pushErr( valMsg( 'contact_email_format', 'E-mail виглядає некоректним.' ), emailIn );
				}

				const rec = formEl.querySelector( 'input[name="recipient_type"]:checked' );
				if ( rec && rec.value === 'other' ) {
					const rn = formEl.querySelector( '[data-role="recipient-other-name"]' );
					const rp = formEl.querySelector( '[data-role="recipient-other-phone"]' );
					if ( ! String( rn && rn.value ? rn.value : '' ).trim() ) {
						markInvalid( rn, true );
						pushErr( valMsg( 'recipient_name', 'Вкажіть імʼя та прізвище отримувача.' ), rn );
					}
					const rpRaw = String( rp && rp.value ? rp.value : '' ).trim();
					if ( ! rpRaw ) {
						markInvalid( rp, true );
						pushErr( valMsg( 'recipient_phone', 'Вкажіть телефон отримувача.' ), rp );
					} else if ( ! phoneLooksValid( rpRaw ) ) {
						markInvalid( rp, true );
						pushErr( valMsg( 'recipient_phone_format', 'Телефон отримувача виглядає некоректним.' ), rp );
					}
				}

				const dt = formEl.querySelector( 'input[name="delivery_type"]:checked' );
				const deliveryVal = dt ? dt.value : '';

				if ( deliveryVal === 'post-office' || deliveryVal === 'parcel-machine' ) {
					const cityWrap = formEl.querySelector( '[data-role="np-city-wrap"]' );
					const whWrap = formEl.querySelector( '[data-role="np-warehouse-wrap"]' );
					const cityRef = checkoutGetNpCityRef( formEl );
					if ( ! cityRef ) {
						markInvalid( cityWrap, true );
						pushErr( valMsg( 'np_city', 'Оберіть місто доставки Нової пошти.' ), cityWrap );
					}
					const wh = formEl.querySelector( '[data-role="np-warehouse-select"]' );
					const whVal = wh && ! wh.disabled ? String( wh.value || '' ).trim() : '';
					if ( ! whVal ) {
						markInvalid( whWrap, true );
						pushErr( valMsg( 'np_warehouse', 'Оберіть відділення або поштомат Нової пошти.' ), whWrap );
					}
				} else if ( deliveryVal === 'courier-city' ) {
					const courierFields = [
						{ role: 'courier-city-input', key: 'courier_city', fb: 'Вкажіть місто для курʼєра.' },
						{ role: 'courier-street-input', key: 'courier_street', fb: 'Вкажіть вулицю.' },
						{ role: 'courier-house-input', key: 'courier_house', fb: 'Вкажіть номер будинку.' },
						{ role: 'courier-apartment-input', key: 'courier_flat', fb: 'Вкажіть номер квартири.' },
					];
					courierFields.forEach( ( c ) => {
						const inp = formEl.querySelector( '[data-role="' + c.role + '"]' );
						if ( ! String( inp && inp.value ? inp.value : '' ).trim() ) {
							markInvalid( inp, true );
							pushErr( valMsg( c.key, c.fb ), inp );
						}
					} );
				}

				if ( errors.length ) {
					showStep1Errors( formEl, errors );
					if ( firstFocus ) {
						try {
							firstFocus.scrollIntoView( { block: 'nearest', behavior: 'smooth' } );
							firstFocus.focus( { preventScroll: true } );
						} catch ( fe ) {
						}
					}
					return false;
				}
				return true;
			}

			function checkoutScrollToFormHeader( formEl, headerSelector ) {
				if ( ! formEl ) {
					return;
				}
				try {
					const head = formEl.querySelector( headerSelector );
					if ( head ) {
						head.scrollIntoView( { block: 'start', behavior: 'smooth' } );
					}
				} catch ( se ) {
				}
			}

			window.corppixCheckoutApi = {
				validateStep1: validateCheckoutStep1,
				setActiveStep: checkoutSetActiveStep,
				scrollToHeader: checkoutScrollToFormHeader,
			};

			applyMandatoryPlaceholdersToForm( document.querySelector( 'form.checkout' ) );
		})();

		(function corppixInitScrollRestore() {
			const storageKey = 'corppix_scroll_restore';

			function getPageUrl() {
				return window.location.origin + window.location.pathname + window.location.search;
			}

			function getStoredData() {
				try {
					return JSON.parse( window.localStorage.getItem( storageKey ) || 'null' );
				} catch ( e ) {
					return null;
				}
			}

			function clearStoredData() {
				try {
					window.localStorage.removeItem( storageKey );
				} catch ( e ) {
				}
			}

			function isBackForwardNavigation( event ) {
				if ( event && event.persisted ) {
					return true;
				}

				if ( window.performance && typeof window.performance.getEntriesByType === 'function' ) {
					const nav = window.performance.getEntriesByType( 'navigation' )[0];
					return !! nav && nav.type === 'back_forward';
				}

				return false;
			}

			function scrollToStoredBlock( data ) {
				const block = document.querySelector( '.js-scroll-restore-block[data-scroll-restore-key="' + data.blockKey + '"]' );

				if ( block ) {
					block.scrollIntoView( { block: 'start', behavior: 'auto' } );
					return;
				}

				if ( typeof data.scrollTop === 'number' ) {
					window.scrollTo( 0, data.scrollTop );
				}
			}

			document.body.addEventListener( 'click', function ( e ) {
				const link = e.target.closest( 'a' );
				if ( ! link ) {
					return;
				}

				const restoreLink = link.closest( '.js-scroll-restore-link[data-role="remember-scroll-restore"]' );
				if ( ! restoreLink ) {
					clearStoredData();
					return;
				}

				if ( e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || restoreLink.target === '_blank' ) {
					return;
				}

				const block = restoreLink.closest( '.js-scroll-restore-block[data-scroll-restore-key]' );
				if ( ! block ) {
					return;
				}

				try {
					window.localStorage.setItem( storageKey, JSON.stringify( {
						sourceUrl: getPageUrl(),
						blockKey: block.dataset.scrollRestoreKey,
						scrollTop: window.pageYOffset + block.getBoundingClientRect().top,
					} ) );
				} catch ( err ) {
				}
			} );

			window.addEventListener( 'pageshow', function ( event ) {
				const data = getStoredData();
				if ( ! data || data.sourceUrl !== getPageUrl() ) {
					return;
				}

				if ( ! isBackForwardNavigation( event ) ) {
					clearStoredData();
					return;
				}

				window.requestAnimationFrame( function () {
					scrollToStoredBlock( data );
					clearStoredData();
				} );
			} );
		})();

        animateBlock(); // innit animate block function
       /* addSubmenuButton('#menu-header-menu', `<svg viewBox="0 0 9.24805 5.43411" xmlns="http://www.w3.org/2000/svg" width="9.248047" height="5.434113" fill="none" customFrame="#000000"><path id="Vector" d="M0 0L4.21875 4.21875L8.4375 0" fill-rule="nonzero" stroke="rgb(114,113,120)" stroke-width="1.145833" transform="matrix(1,0,0,-1,0.405273,5.02899)" /></svg>`); // innit add for submenu button*/
       const mainSlider = document.querySelector('.js-main-slider');
       const blogSliders = document.querySelectorAll('.js-blog-slider');
       const collectionSlider = document.querySelector('.js-collection-slider');
       const interiorSlider = document.querySelector('.js-interior-slider');
       const reviewsSlider = document.querySelector('.js-reviews-slider');
       const presentsSlider = document.querySelector('.js-presents-slider');
       const productGalleryRoots = document.querySelectorAll('.js-product-gallery');

       blogSliders.forEach( blogSlider => {
           const blogPagination = blogSlider.querySelector('.js-blog-slider-pagination');
           const blogSlideCount = blogSlider.querySelectorAll('.swiper-slide').length;

           new Swiper(blogSlider, {
               loop: blogSlideCount > 1,
               slidesPerView: 1,
               watchOverflow: true,
               autoplay: blogSlideCount > 1 ? {
                   delay: 5000,
                   disableOnInteraction: false,
                   pauseOnMouseEnter: true,
               } : false,
               pagination: {
                   el: blogPagination,
                   clickable: true,
               },
           });
       } );
        
        if (presentsSlider) {
            new Swiper(presentsSlider , {
                loop: true,
                spaceBetween: 15,
                slidesPerView: 4,
                breakpoints: {
                    320: { slidesPerView: "auto"},
                    481: { slidesPerView: 2 },
                    560: { slidesPerView: 3 },
                    993: { slidesPerView: 4 },
                },
            });
        }
       
        if (reviewsSlider) {
            new Swiper(reviewsSlider , {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 3,
                navigation: {
                    nextEl: ".js-reviews-next",
                    prevEl: ".js-reviews-prev",
                },
                pagination: {
                    el: ".js-reviews-pagination",
                    type: "progressbar",
                },
                breakpoints: {
                    320: { slidesPerView: "auto",
                        spaceBetween: 6,
                    },
                    561: { slidesPerView: 2, spaceBetween: 20, },
                    993: { slidesPerView: 3 },
                },
            });
        }
        
        if (interiorSlider) {
            new Swiper(interiorSlider , {
                loop: true,
                spaceBetween: 15,
                slidesPerView: 4,
                navigation: {
                    nextEl: ".js-interior-next",
                    prevEl: ".js-interior-prev",
                },
                
                breakpoints: {
                    320: { slidesPerView: "auto"},
                    481: { slidesPerView: 2 },
                    560: { slidesPerView: 3 },
                    993: { slidesPerView: 4 },
                },
            });
        }
       
       if (collectionSlider) {
           new Swiper(collectionSlider , {
               loop: true,
               spaceBetween: 15,
               slidesPerView: 1,
               breakpoints: {
                   320: { slidesPerView: 1 },
                   560: { slidesPerView: 2 },
                   992: { slidesPerView: 3 },
               },
               navigation: {
                   nextEl: ".js-collection-next",
                   prevEl: ".js-collection-prev",
               },
           });
       }

       const singleRelatedSlider = document.querySelector('.js-single-related-slider');
       if (singleRelatedSlider && typeof Swiper !== 'undefined') {
           const relatedSlideCount = singleRelatedSlider.querySelectorAll('.swiper-slide').length;
           const relatedNext = document.querySelector('.js-single-related-next');
           const relatedPrev = document.querySelector('.js-single-related-prev');
           new Swiper(singleRelatedSlider, {
               loop: relatedSlideCount > 3,
               spaceBetween: 15,
               slidesPerView: 1,
               watchOverflow: true,
               breakpoints: {
                   320: { slidesPerView: 1 },
                   560: { slidesPerView: 2 },
                   992: { slidesPerView: 3 },
               },
               navigation: relatedSlideCount > 1 ? {
                   nextEl: relatedNext,
                   prevEl: relatedPrev,
               } : {},
           });
           if (relatedSlideCount <= 1 && relatedNext && relatedPrev) {
               relatedNext.style.display = 'none';
               relatedPrev.style.display = 'none';
           }
       }
       
       if (mainSlider) {
           const resetSlideVideos = () => {
               const wrappers = mainSlider.querySelectorAll('.js-video-wrapper');
               wrappers.forEach(wrapper => {
                   const videoEl = wrapper.querySelector('video');
                   if (videoEl) {
                       videoEl.pause();
                       videoEl.currentTime = 0;
                   }
                   const preview = wrapper.querySelector('.js-video-image');
                   if (preview) {
                       preview.style.display = 'block';
                   }
                   const btn = wrapper.querySelector('[data-role="play-slide-video"]');
                   if (btn) {
                       btn.style.display = '';
                   }
               });
           };

           const mainSwiper = new Swiper(mainSlider , {
               loop: true,
               navigation: {
                   nextEl: ".main-slider-next",
                   prevEl: ".main-slider-prev",
               },
               on: {
                   slideChangeTransitionStart() {
                       resetSlideVideos();
                   },
               },
           });
       }
       
       function slideProductMainGalleryToAttachment(mainGalleryEl, attachmentId) {
           const swiper = mainGalleryEl && mainGalleryEl.swiper;
           if (!swiper || attachmentId == null || attachmentId === '') return;
           const slides = mainGalleryEl.querySelectorAll('.swiper-slide[data-attachment-id]');
           let target = 0;
           slides.forEach((el, idx) => {
               if (String(el.getAttribute('data-attachment-id')) === String(attachmentId)) {
                   target = idx;
               }
           });
           swiper.slideTo(target);
       }

       const productGalleryMainSwipers = [];
       const productGalleryLightboxEscapes = [];

       if (productGalleryRoots.length && typeof Swiper !== 'undefined') {
           productGalleryRoots.forEach((productGalleryRoot) => {
               const mainGalleryEl = productGalleryRoot.querySelector('.js-product-gallery-main');
               const thumbsGalleryEl = productGalleryRoot.querySelector('.js-product-gallery-thumbs');
               const prevBtn = productGalleryRoot.querySelector('.js-product-gallery-prev');
               const nextBtn = productGalleryRoot.querySelector('.js-product-gallery-next');

               if (!mainGalleryEl) return;

               let thumbSwiperInstance = null;
               if (thumbsGalleryEl) {
                   thumbSwiperInstance = new Swiper(thumbsGalleryEl, {
                       spaceBetween: 10,
                       slidesPerView: 4,
                       watchSlidesProgress: true,
                   });
               }

               const mainGalleryOpts = {
                   spaceBetween: 0,
                   navigation: {
                       nextEl: nextBtn,
                       prevEl: prevBtn,
                   },
               };
               if (thumbSwiperInstance) {
                   mainGalleryOpts.thumbs = { swiper: thumbSwiperInstance };
               }
               const productMainSwiper = new Swiper(mainGalleryEl, mainGalleryOpts);
               const slideCount = mainGalleryEl.querySelectorAll('.swiper-slide').length;
               if (slideCount <= 1 && prevBtn && nextBtn) {
                   prevBtn.style.display = 'none';
                   nextBtn.style.display = 'none';
               }

               productGalleryMainSwipers.push({ mainEl: mainGalleryEl, swiper: productMainSwiper });

               const lightboxEl = productGalleryRoot.querySelector('.js-product-gallery-lightbox');
               const lightboxMainEl = productGalleryRoot.querySelector('.js-product-gallery-lightbox-main');
               const lightboxThumbsEl = productGalleryRoot.querySelector('.js-product-gallery-lightbox-thumbs');
               if (lightboxEl && lightboxMainEl) {
                   document.body.appendChild(lightboxEl);
                   let lbThumbsSwiper = null;
                   if (lightboxThumbsEl) {
                       lbThumbsSwiper = new Swiper(lightboxThumbsEl, {
                           spaceBetween: 10,
                           slidesPerView: 3,
                           watchSlidesProgress: true,
                           breakpoints: {
                               480: { slidesPerView: 4, spaceBetween: 10 },
                               768: { slidesPerView: 5, spaceBetween: 10 },
                               992: { slidesPerView: 6, spaceBetween: 10 },
                           },
                       });
                   }
                   const lbNavPrev = lightboxEl.querySelector('.js-product-gallery-lightbox-prev');
                   const lbNavNext = lightboxEl.querySelector('.js-product-gallery-lightbox-next');
                   const lbMainOpts = {
                       spaceBetween: 0,
                       navigation: {
                           nextEl: lbNavNext,
                           prevEl: lbNavPrev,
                       },
                   };
                   if (lbThumbsSwiper) {
                       lbMainOpts.thumbs = { swiper: lbThumbsSwiper };
                   }
                   const lbMainSwiper = new Swiper(lightboxMainEl, lbMainOpts);
                   const lbSlideCount = lightboxMainEl.querySelectorAll('.swiper-slide').length;
                   if (lbSlideCount <= 1 && lbNavPrev && lbNavNext) {
                       lbNavPrev.style.display = 'none';
                       lbNavNext.style.display = 'none';
                   }

                   const openProductGalleryLightbox = () => {
                       lightboxEl.classList.remove('hidden');
                       document.body.style.overflow = 'hidden';
                       lbMainSwiper.slideTo(productMainSwiper.activeIndex, 0);
                       lbMainSwiper.update();
                       if (lbThumbsSwiper) {
                           lbThumbsSwiper.update();
                       }
                   };

                   const closeProductGalleryLightbox = () => {
                       lightboxEl.classList.add('hidden');
                       document.body.style.overflow = '';
                   };

                   productGalleryLightboxEscapes.push({ el: lightboxEl, close: closeProductGalleryLightbox });

                   mainGalleryEl.addEventListener('click', (e) => {
                       if (e.target.closest('.slider-button')) return;
                       if (!e.target.closest('.js-product-gallery-main-slide')) return;
                       openProductGalleryLightbox();
                   });

                   const lbCloseBtn = lightboxEl.querySelector('.js-product-gallery-lightbox-close');
                   const lbBackdrop = lightboxEl.querySelector('.js-product-gallery-lightbox-backdrop');
                   if (lbCloseBtn) {
                       lbCloseBtn.addEventListener('click', (ev) => {
                           ev.preventDefault();
                           ev.stopPropagation();
                           closeProductGalleryLightbox();
                       });
                   }
                   if (lbBackdrop) {
                       lbBackdrop.addEventListener('click', closeProductGalleryLightbox);
                   }
               }
           });

           if (typeof jQuery !== 'undefined') {
               const $vf = jQuery('.variations_form');
               if ($vf.length && productGalleryMainSwipers.length) {
                   $vf.off('show_variation.corppixMultiGallery reset_data.corppixMultiGallery')
                       .on('show_variation.corppixMultiGallery', (event, variation) => {
                           if (variation && variation.image_id) {
                               productGalleryMainSwipers.forEach(({ mainEl }) => {
                                   slideProductMainGalleryToAttachment(mainEl, variation.image_id);
                               });
                           }
                       })
                       .on('reset_data.corppixMultiGallery', () => {
                           productGalleryMainSwipers.forEach(({ swiper }) => {
                               swiper.slideTo(0);
                           });
                       });
               }
           }

           if (productGalleryLightboxEscapes.length) {
               document.addEventListener('keydown', (e) => {
                   if (e.key !== 'Escape') return;
                   productGalleryLightboxEscapes.forEach(({ el, close }) => {
                       if (!el.classList.contains('hidden')) close();
                   });
               });
           }
       }

       // Parallax effect for slider images on scroll (only when elements are visible by viewport)
       const parallaxEls = document.querySelectorAll('.js-parallax-bg, .js-parallax-img, .js-parallax-model, .js-parallax-benefits-smoke, .js-parallax-benefits-emblem, .js-parallax-engraving, .js-parallax-engraving-desktop, .js-parallax-appreciates, .js-parallax-form-smoke, .js-parallax-delivery, .js-parallax-have-questions-bg, .js-parallax-have-questions-front, .js-parallax-steel-bg, .js-parallax-faq, .js-parallax-small-banner, .js-parallax-features, .js-parallax-production-step');
       if (parallaxEls.length) {
           const RATES = { 'js-parallax-bg': 0.25, 'js-parallax-img': 0.18, 'js-parallax-model': 0.12, 'js-parallax-benefits-smoke': 0.2, 'js-parallax-benefits-emblem': 0.05, 'js-parallax-engraving': 0.075, 'js-parallax-engraving-desktop': 0.06, 'js-parallax-appreciates': 0.06, 'js-parallax-form-smoke': 0.15, 'js-parallax-delivery': 0.06, 'js-parallax-have-questions-bg': 0.05, 'js-parallax-have-questions-front': 0.05, 'js-parallax-steel-bg': 0.1, 'js-parallax-faq': 0.06, 'js-parallax-small-banner': 0.1, 'js-parallax-features': 0.08, 'js-parallax-production-step': 0.08 };
           const APPRECIATES_BASE_OFFSET = -15;
           const DELIVERY_BASE_OFFSET = -15;
           const ENGRAVING_BASE_OFFSET = -15;
           const FAQ_BASE_OFFSET = -15;
           const BENEFITS_BREAKPOINT = 481;
           const SLIDER_BREAKPOINT = 994;
           const ENGRAVING_BREAKPOINT = 561;
           const STEEL_BG_BREAKPOINT = 768;
           let ticking = false;

           function isParallaxElVisible(el, w) {
               if (el.classList.contains('js-parallax-small-banner')) return true;
               const isBenefits = el.classList.contains('js-parallax-benefits-smoke') || el.classList.contains('js-parallax-benefits-emblem');
               const isSliderBg = el.classList.contains('js-parallax-bg') && !el.classList.contains('js-parallax-img');
               const isSliderImg = el.classList.contains('js-parallax-img');
               const isEngraving = el.classList.contains('js-parallax-engraving');
               const isEngravingDesktop = el.classList.contains('js-parallax-engraving-desktop');
               const isSteelBg = el.classList.contains('js-parallax-steel-bg');
               if (isBenefits && w < BENEFITS_BREAKPOINT) return false;
               if (isSteelBg && w <= STEEL_BG_BREAKPOINT) return false;
               if (isSliderBg && w >= SLIDER_BREAKPOINT) return false;
               if (isSliderImg && w < SLIDER_BREAKPOINT) return false;
               if (isEngraving && w > ENGRAVING_BREAKPOINT) return false;
               if (isEngravingDesktop && w <= ENGRAVING_BREAKPOINT) return false;
               return true;
           }

           function updateParallax() {
               const w = window.innerWidth;
               const vh = window.innerHeight / 2;
               const engravingEls = [...parallaxEls].filter(el => el.classList.contains('js-parallax-engraving'));
               const engravingOffset = engravingEls.length && w <= ENGRAVING_BREAKPOINT
                   ? (() => {
                       const first = engravingEls[0];
                       const rect = first.getBoundingClientRect();
                       const centerY = rect.top + rect.height / 2;
                       return (vh - centerY) * RATES['js-parallax-engraving'];
                   })()
                   : null;
               parallaxEls.forEach(el => {
                   if (!isParallaxElVisible(el, w)) return;
                   let offset;
                   if (el.classList.contains('js-parallax-engraving') && engravingOffset !== null) {
                       offset = engravingOffset + ENGRAVING_BASE_OFFSET;
                   } else {
                       const rect = el.getBoundingClientRect();
                       const centerY = rect.top + rect.height / 2;
                       const key = Array.from(el.classList).find(c => RATES[c]) || 'js-parallax-bg';
                       const rate = RATES[key];
                       offset = (vh - centerY) * rate;
                       if (key === 'js-parallax-appreciates') {
                           offset += APPRECIATES_BASE_OFFSET;
                       }
                       if (key === 'js-parallax-delivery') {
                           offset += DELIVERY_BASE_OFFSET;
                       }
                       if (key === 'js-parallax-engraving-desktop') {
                           offset += ENGRAVING_BASE_OFFSET;
                       }
                       if (key === 'js-parallax-faq') {
                           offset += FAQ_BASE_OFFSET;
                       }
                   }
                   const haveQuestionsRotateY = (el.classList.contains('js-parallax-have-questions-bg') || el.classList.contains('js-parallax-have-questions-front'))
                           ? offset * 0.24
                           : 0;
                   if (el.classList.contains('js-parallax-form-smoke')) {
                       el.style.transform = `translate3d(calc(-50% + ${offset}px), -50%, 0)`;
                   } else if (el.classList.contains('js-parallax-have-questions-bg')) {
                       el.style.transform = `translate3d(-50%, calc(-50% + ${offset}px), 0) rotateY(${haveQuestionsRotateY}deg)`;
                   } else if (el.classList.contains('js-parallax-have-questions-front')) {
                       el.style.transform = `translate3d(0, ${offset}px, 0) rotateY(${haveQuestionsRotateY}deg)`;
                   } else {
                       el.style.transform = `translate3d(0, ${offset}px, 0)`;
                   }
               });
               ticking = false;
           }

           function onScrollParallax() {
               if (ticking) return;
               ticking = true;
               requestAnimationFrame(updateParallax);
           }

           window.addEventListener('scroll', onScrollParallax, { passive: true });
           updateParallax();
       }

       // Logo 3D coin rotation on scroll
       const logoCoin = document.querySelector('.js-logo-coin');
       if (logoCoin) {
           const SCROLL_TO_DEG = 0.2;
           let rotationY = 0;
           let lastScrollY = window.scrollY || window.pageYOffset;
           let scrollTimeout = null;
           let isSettling = false;

           function snapToInitial() {
               isSettling = true;
               rotationY = 0;
               logoCoin.style.transition = 'transform 0.4s ease-out';
               logoCoin.style.transform = 'rotateY(0deg)';
               setTimeout(() => {
                   logoCoin.style.transition = '';
                   isSettling = false;
               }, 400);
           }

           function onLogoScroll() {
               if (isSettling) return;
               const scrollY = window.scrollY || window.pageYOffset;
               const deltaY = scrollY - lastScrollY;
               lastScrollY = scrollY;

               if (Math.abs(deltaY) > 0) {
                   logoCoin.style.transition = 'none';
                   rotationY += deltaY * SCROLL_TO_DEG;
                   logoCoin.style.transform = `rotateY(${rotationY}deg)`;
               }

               clearTimeout(scrollTimeout);
               scrollTimeout = setTimeout(snapToInitial, 120);
           }

           window.addEventListener('scroll', onLogoScroll, { passive: true });
       }
        
        // Add global handler for click blur
        document.body.addEventListener('focusout', event => {
            const blurTarget = event.target;
            const blurElem = blurTarget.closest('[data-role]');
            const ROLE = blurElem ? blurElem.dataset.role : null;
            if ( !ROLE ) return;
            
            switch ( ROLE ) {
                case 'checkout-contact-name' : {
                    event.preventDefault();
                    const contactName = document.querySelector('.js-contact-name');
                    
                    if (contactName) {
                        contactName.innerText = blurElem.value
                    }
                } break;
                case 'checkout-contact-phone': {
                    event.preventDefault();
                    const contactPhone = document.querySelector('.js-contact-phone');
                    if (contactPhone) {
                        contactPhone.innerText = blurElem.value
                    }
                } break;
                case 'checkout-contact-email': {
                    event.preventDefault();
                    const contactEmail = document.querySelector('.js-contact-email');
                    if (contactEmail) {
                        contactEmail.innerText = blurElem.value
                    }
                } break;
                case 'checkout-contact-comment': {
                    event.preventDefault();
                    
                    const contactComment = document.querySelector('.js-contact-comment');
                    if (contactComment) {
                        contactComment.innerText = blurElem.value
                    }
                } break;
				case 'courier-city-input':
				case 'courier-street-input':
				case 'courier-house-input':
				case 'courier-apartment-input': {
					event.preventDefault();
					const formCheckout = blurElem.closest ? blurElem.closest( 'form.checkout' ) : null;
					checkoutSyncAllCourierSummaryFields( formCheckout );
				} break;
            }
        })
        
		/**
		 * Add global handler for click event
		 * The main idea - to improve site performance
		 * We added only 1 event handler to "click" event
		 * and then use date-role attribute on each( needed ) elements
		 * to define on which element event was executed.
		 */
		document.body.addEventListener( 'click', event => {
			const clickTarget = event.target;
			const clickElem = clickTarget.closest('[data-role]');
			const ROLE = clickElem ? clickElem.dataset.role : null;

			if ( !ROLE ) return;
            switch ( ROLE ) {
				case 'share-article': {
					event.preventDefault();
					const shareUrl = clickElem.dataset.link || window.location.href;
					const shareTitle = clickElem.dataset.title || document.title;

					if ( navigator.share ) {
						navigator.share( {
							title: shareTitle,
							url: shareUrl
						} ).catch( error => {
							if ( error && error.name !== 'AbortError' && navigator.clipboard ) {
								navigator.clipboard.writeText( shareUrl );
							}
						} );
					} else if ( navigator.clipboard ) {
						navigator.clipboard.writeText( shareUrl );
					}
					break;
				}

				case 'copy-article-link':
					event.preventDefault();

					if ( navigator.clipboard && clickElem.dataset.link ) {
						navigator.clipboard.writeText( clickElem.dataset.link );
					}
					break;

				case 'filter-posts':
				case 'load-more-posts': {
					event.preventDefault();
					const postsRoot = clickElem.closest( '.js-posts-list' );
					const postsGrid = postsRoot ? postsRoot.querySelector( '.js-posts-grid' ) : null;
					const moreWrap = postsRoot ? postsRoot.querySelector( '.js-posts-more-wrap' ) : null;
					const moreButton = moreWrap ? moreWrap.querySelector( '[data-role="load-more-posts"]' ) : null;
					const nonce = postsRoot ? postsRoot.dataset.nonce : '';
					const postsAjaxUrl = postsRoot ? postsRoot.dataset.ajaxUrl : '';

					if ( ! postsRoot || ! postsGrid || ! moreWrap || ! moreButton || ! nonce || ! postsAjaxUrl || clickElem.disabled || postsRoot.dataset.loading === 'true' ) {
						break;
					}

					const isFilter = ROLE === 'filter-posts';
					const categoryId = isFilter ? clickElem.dataset.category : moreButton.dataset.category;
					const page = isFilter ? 1 : ( parseInt( moreButton.dataset.page, 10 ) || 1 ) + 1;
					const requestData = new FormData();
					requestData.append( 'action', 'corppix_load_posts_list' );
					requestData.append( 'nonce', nonce );
					requestData.append( 'page', String( page ) );
					requestData.append( 'category_id', String( categoryId || 0 ) );

					if ( isFilter ) {
						postsRoot.querySelectorAll( '.js-posts-filter' ).forEach( filterButton => {
							const isActive = filterButton === clickElem;
							filterButton.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );
							filterButton.classList.toggle( 'text-[#1B1B1B]', isActive );
							filterButton.classList.toggle( 'text-[#6A6A6A]', ! isActive );
							filterButton.classList.toggle( 'after:w-full', isActive );
							filterButton.classList.toggle( 'after:w-0', ! isActive );
						} );
						postsGrid.style.opacity = '0.5';
						postsGrid.style.pointerEvents = 'none';
					}

					postsRoot.dataset.loading = 'true';
					clickElem.disabled = true;
					fetch( postsAjaxUrl, {
						method: 'POST',
						credentials: 'same-origin',
						body: requestData,
					} )
						.then( response => response.json() )
						.then( responseData => {
							if ( ! responseData || ! responseData.success || ! responseData.data ) {
								return;
							}

							if ( isFilter ) {
								postsGrid.innerHTML = responseData.data.html || '';
							} else {
								postsGrid.insertAdjacentHTML( 'beforeend', responseData.data.html || '' );
							}

							moreButton.dataset.page = String( responseData.data.page || page );
							moreButton.dataset.category = String( categoryId || 0 );
							moreWrap.classList.toggle( 'hidden', ! responseData.data.has_more );
							window.requestAnimationFrame( () => lazyImage( postsGrid ) );
						} )
						.finally( () => {
							postsRoot.dataset.loading = 'false';
							clickElem.disabled = false;
							postsGrid.style.opacity = '';
							postsGrid.style.pointerEvents = '';
						} );
				} break;
                case 'set-page' : {
                    event.preventDefault();
                    const page = clickElem?.dataset?.page ? parseInt(clickElem.dataset.page, 10) : 1;
                    if (typeof loadFilteredProducts === 'function') {
                        loadFilteredProducts(page, { scrollToBlock: true });
                    }
                } break;
                case 'button-pagination': {
                    event.preventDefault();
                } break;
                case 'toggle-faq': {
                    event.preventDefault();
                    const parentFaq = clickElem.closest('.js-faq-item');
                    const answer = parentFaq ? parentFaq.querySelector('.js-faq-answer') : null;
                    const icon = parentFaq ? parentFaq.querySelector('.js-faq-icon') : null;
                    const isAlreadyOpen = answer && !$(answer).is(':hidden');

                    const setAllIconsToPlus = () => {
                        document.querySelectorAll('.js-faq-icon').forEach((i) => { i.textContent = '+'; });
                    };
                    const setIcon = (open) => {
                        if (icon) icon.textContent = open ? '−' : '+';
                    };

                    if (isAlreadyOpen) {
                        $(answer).slideUp();
                        setIcon(false);
                    } else {
                        const faqWrap = document.querySelectorAll('.js-faq-wrap');
                        faqWrap && faqWrap.forEach((wrap) => {
                            const answers = wrap.querySelectorAll('.js-faq-answer');
                            answers && answers.forEach((a) => $(a).slideUp());
                        });
                        setAllIconsToPlus();
                        if (answer) {
                            $(answer).slideDown();
                            setIcon(true);
                        }
                    }
                } break;
                case 'show-password': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-password-wrap');
                    const passInput = parent.querySelector('.js-pass-input');
                    if (!passInput) return;
                    const typeInput = passInput.type;
                    
                    if(typeInput === 'password') {
                        passInput.type = 'text';
                    } else {
                        passInput.type = 'password';
                    }
                    
                } break
                case 'open-modal': {
                    event.preventDefault();
                    const body = document.querySelector('body');
                    const popupSelector = clickElem.dataset.popup;
                    if(!popupSelector) return;
                    const popup = document.querySelector(`#${popupSelector}`);
                    close_popups();
                    
                    if(popup) {
                        if (popup.id === 'quick_order_popup') {
                            const source = document.querySelector('.js-single-quick-order-source');
                            const hidLine = popup.querySelector('.js-quick-order-product-id');
                            const hidParent = popup.querySelector('.js-quick-order-parent-product-id');
                            const hidName = popup.querySelector('.js-quick-order-product-name');
                            if (!source || !hidLine || !hidParent || !hidName) {
                                return;
                            }
                            const parentId = source.dataset.parentProductId || '';
                            const addBtn = document.querySelector('.js-single-add-to-cart');
                            const variationId = addBtn && addBtn.dataset.variationId
                                ? parseInt(addBtn.dataset.variationId, 10)
                                : 0;
                            const isVariable = source.dataset.variable === '1';

                            if (isVariable && !variationId) {
                                const msgEl = document.querySelector('.js-single-cart-message');
                                if (msgEl) {
                                    msgEl.textContent = 'Оберіть колір моделі перед швидким замовленням.';
                                    msgEl.classList.remove('hidden');
                                }
                                return;
                            }

                            const lineId = isVariable && variationId ? variationId : parseInt(parentId, 10) || 0;
                            hidParent.value = String(parentId);
                            hidLine.value = String(lineId);
                            hidName.value = source.dataset.currentDisplayName || source.dataset.baseName || '';
                        }

                        popup.classList.add('show');
                        body && body.classList.add('menu-open');
                        if ( popup.id === 'cart_item_edit_popup' || popup.id === 'main_form_success_popup' || popup.id === 'quick_order_popup' || popup.id === 'quick-order-success' ) {
                            popup.setAttribute( 'aria-hidden', 'false' );
                        }
                    }
                } break;
                case 'logout': {
                    event.preventDefault();
                    const data = new FormData();
                    data.append( 'action', 'log_out_user' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if(responseData.success) {
                                    location.reload();
                                }
                            })
                } break;
                case 'close-popup': {
                    close_popups();
                } break;
                case 'cookie-consent-accept': {
                    event.preventDefault();
                    document.cookie = 'corppix_cookie_consent=1;path=/;max-age=31536000;SameSite=Lax';
                    const acceptBanner = document.querySelector( '.js-cookie-consent-banner' );
                    if ( acceptBanner ) {
                        acceptBanner.classList.remove( 'is-open' );
                        acceptBanner.setAttribute( 'aria-hidden', 'true' );
                    }
                } break;
                case 'cookie-consent-close': {
                    event.preventDefault();
                    const dismissBanner = document.querySelector( '.js-cookie-consent-banner' );
                    if ( dismissBanner ) {
                        dismissBanner.classList.remove( 'is-open' );
                        dismissBanner.setAttribute( 'aria-hidden', 'true' );
                    }
                } break;
                case 'open-cart': {
                    event.preventDefault();
                    openSideCart();
                } break;
                case 'back-to-contact': {
                    if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
                        break;
                    }
                    event.preventDefault();
                    const checkoutFormBackContact = clickElem.closest( 'form.checkout' );
                    if ( checkoutFormBackContact && window.corppixCheckoutApi ) {
                        window.corppixCheckoutApi.setActiveStep( checkoutFormBackContact, 'contact-fields' );
                    }
                } break;
                case 'back-to-payment':
                case 'back-to-payment-type': {
                    if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
                        break;
                    }
                    event.preventDefault();
                    const checkoutFormBackPay = clickElem.closest( 'form.checkout' );
                    if ( checkoutFormBackPay && window.corppixCheckoutApi ) {
                        window.corppixCheckoutApi.setActiveStep( checkoutFormBackPay, 'payment-method' );
                        window.corppixCheckoutApi.scrollToHeader( checkoutFormBackPay, '.js-payment-method' );
                    }
                } break;
                case 'go-to-confirmation': {
                    if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
                        break;
                    }
                    event.preventDefault();
                    const checkoutFormConfirm = clickElem.closest( 'form.checkout' );
                    if ( checkoutFormConfirm && window.corppixCheckoutApi ) {
                        window.corppixCheckoutApi.setActiveStep( checkoutFormConfirm, 'confirmation-order' );
                        window.corppixCheckoutApi.scrollToHeader( checkoutFormConfirm, '.js-confirmation-order' );
                    }
                    if ( typeof window.corppixRefreshCheckoutConfirmOrderGate === 'function' ) {
                        window.corppixRefreshCheckoutConfirmOrderGate();
                    }
                } break;
                case 'go-to-payment': {
                    if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
                        break;
                    }
                    const checkoutFormPay = clickElem.closest( 'form.checkout' );
                    if ( ! checkoutFormPay || ! window.corppixCheckoutApi ) {
                        break;
                    }
                    if ( ! window.corppixCheckoutApi.validateStep1( checkoutFormPay ) ) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        break;
                    }
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    window.corppixCheckoutApi.setActiveStep( checkoutFormPay, 'payment-method' );
                    window.corppixCheckoutApi.scrollToHeader( checkoutFormPay, '.js-payment-method' );
                } break;
                case 'apply-coupon': {
                    if ( typeof var_from_php === 'undefined' || ! var_from_php.ajax_url || ! var_from_php.is_checkout ) {
                        break;
                    }
                    event.preventDefault();
                    if ( ! var_from_php.checkout_coupon_nonce ) {
                        break;
                    }
                    const couponForm = clickElem.closest( 'form.checkout' );
                    const couponInp = couponForm ? couponForm.querySelector( '.js-checkout-coupon-input' ) : document.querySelector( '.js-checkout-coupon-input' );
                    const code = couponInp ? String( couponInp.value || '' ).trim() : '';
                    if ( ! code || clickElem.disabled ) {
                        break;
                    }
                    clickElem.disabled = true;
                    const fd = new FormData();
                    fd.append( 'action', 'corppix_checkout_apply_coupon' );
                    fd.append( 'nonce', var_from_php.checkout_coupon_nonce );
                    fd.append( 'coupon_code', code );
                    fetch( var_from_php.ajax_url, { method: 'POST', credentials: 'same-origin', body: fd } )
                        .then( ( r ) => r.json() )
                        .then( ( data ) => {
                            clickElem.disabled = false;
                            if ( data.success && data.data ) {
                                corppixApplyCheckoutSidebarFromAjaxData( data.data );
                                if ( couponInp ) {
                                    couponInp.value = '';
                                }
                            } else if ( data && data.data && data.data.message ) {
                                window.alert( data.data.message );
                            }
                            if ( typeof window.corppixRefreshCheckoutCouponApplyGate === 'function' ) {
                                window.corppixRefreshCheckoutCouponApplyGate();
                            }
                        } )
                        .catch( () => {
                            clickElem.disabled = false;
                            if ( typeof window.corppixRefreshCheckoutCouponApplyGate === 'function' ) {
                                window.corppixRefreshCheckoutCouponApplyGate();
                            }
                        } );
                } break;
                case 'confirm-order': {
                    if ( typeof var_from_php === 'undefined' || ! var_from_php.ajax_url || ! var_from_php.is_checkout || ! var_from_php.checkout_place_order_nonce ) {
                        break;
                    }
                    const placeForm = clickElem.closest( 'form.checkout' );
                    if ( ! placeForm || clickElem.disabled ) {
                        break;
                    }
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    if ( window.corppixCheckoutApi && ! window.corppixCheckoutApi.validateStep1( placeForm ) ) {
                        break;
                    }
                    const p1 = placeForm.querySelector( '[data-role="checkout-confirm-order-details"]' );
                    const p2 = placeForm.querySelector( '[data-role="checkout-confirm-privacy-policy"]' );
                    if ( ! p1 || ! p2 || ! p1.checked || ! p2.checked ) {
                        break;
                    }
                    const fdPlace = new FormData( placeForm );
                    fdPlace.append( 'action', 'corppix_checkout_place_order' );
                    fdPlace.append( 'nonce', var_from_php.checkout_place_order_nonce );
                    const citySelPlace = placeForm.querySelector( '[data-role="np-city-select"]' );
                    const whSelPlace = placeForm.querySelector( '[data-role="np-warehouse-select"]' );
                    if ( citySelPlace && citySelPlace.selectedOptions && citySelPlace.selectedOptions[ 0 ] ) {
                        fdPlace.append( 'delivery_city_label', String( citySelPlace.selectedOptions[ 0 ].textContent || '' ).trim() );
                    }
                    if ( whSelPlace && whSelPlace.selectedOptions && whSelPlace.selectedOptions[ 0 ] ) {
                        fdPlace.append( 'post_office_label', String( whSelPlace.selectedOptions[ 0 ].textContent || '' ).trim() );
                    }
                    const dtPlace = placeForm.querySelector( 'input[name="delivery_type"]:checked' );
                    if ( dtPlace && dtPlace.dataset && dtPlace.dataset.title ) {
                        fdPlace.append( 'delivery_type_label', String( dtPlace.dataset.title || '' ).trim() );
                    }
                    const payPlace = placeForm.querySelector( 'input[name="payment-type"]:checked' );
                    if ( payPlace && payPlace.dataset && payPlace.dataset.title ) {
                        fdPlace.append( 'payment_type_label', String( payPlace.dataset.title || '' ).trim() );
                    }
                    const placeOrderLoader = placeForm.querySelector( '.js-checkout-place-order-loader' );
                    function setCheckoutPlaceOrderLoading( on ) {
                        if ( placeOrderLoader ) {
                            placeOrderLoader.classList.toggle( 'hidden', ! on );
                            placeOrderLoader.setAttribute( 'aria-hidden', on ? 'false' : 'true' );
                        }
                        clickElem.setAttribute( 'aria-busy', on ? 'true' : 'false' );
                    }
                    setCheckoutPlaceOrderLoading( true );
                    clickElem.disabled = true;
                    fetch( var_from_php.ajax_url, { method: 'POST', credentials: 'same-origin', body: fdPlace } )
                        .then( ( r ) => {
                            if ( ! r.ok ) {
                                throw new Error( 'checkout_place_order_http_' + r.status );
                            }
                            return r.json();
                        } )
                        .then( ( data ) => {
                            corppixHandlePlaceOrderResponse( data, clickElem, setCheckoutPlaceOrderLoading );
                        } )
                        .catch( () => {
                            setCheckoutPlaceOrderLoading( false );
                            clickElem.disabled = false;
                            window.alert( t( 'generic_checkout_error', 'Помилка оформлення.' ) );
                            if ( typeof window.corppixRefreshCheckoutConfirmOrderGate === 'function' ) {
                                window.corppixRefreshCheckoutConfirmOrderGate();
                            }
                        } );
                } break;
                case 'close-side-cart': {
                    event.preventDefault();
                    closeSideCart();
                } break;
                case 'cart-item-edit-open': {
                    event.preventDefault();
                    const cartKey = clickElem.dataset.cartItemKey;
                    if (!cartKey || typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;
                    const inner = document.querySelector('.js-cart-item-edit-popup-inner');
                    if (!inner) return;
                    inner.innerHTML = `<p class="p-[24px] text-center text-[14px] text-[#848484]">${t( 'loading_ellipsis', 'Завантаження…' )}</p>`;
                    const fd = new FormData();
                    fd.append('action', 'corppix_cart_item_edit_form');
                    fd.append('cart_item_key', cartKey);
                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success && data.data && data.data.html) {
                                inner.innerHTML = data.data.html;
                                if (typeof window.corppixOpenPopupById === 'function') {
                                    window.corppixOpenPopupById('cart_item_edit_popup');
                                }
                            } else {
                                inner.innerHTML = '';
                            }
                        })
                        .catch(() => {
                            inner.innerHTML = '';
                        });
                } break;
                case 'cart-edit-select-variation': {
                    event.preventDefault();
                    const vid = clickElem.dataset.variationId;
                    const unitPrice = clickElem.dataset.unitPrice;
                    const form = clickElem.closest('.js-cart-edit-form');
                    if (!form || !vid) return;
                    const hidden = form.querySelector('.js-cart-edit-selected-variation-id');
                    if (hidden) hidden.value = vid;
                    const priceEl = form.querySelector('.js-cart-edit-product-price');
                    if (priceEl && unitPrice !== undefined && unitPrice !== '') {
                        priceEl.setAttribute('data-unit-price', unitPrice);
                    }
                    corppixUpdateCartEditLinePrice(form);
                    form.querySelectorAll('.js-cart-edit-variation-option').forEach((opt) => {
                        const active = String(opt.dataset.variationId) === String(vid);
                        opt.classList.toggle('border-[#B6F000]', active);
                        opt.classList.toggle('shadow-[0_0_0_1px_#B6F000_inset]', active);
                        opt.classList.toggle('border-[#D9D9D9]', !active);
                        const radio = opt.querySelector('.js-cart-edit-variation-radio');
                        if (radio) radio.checked = active;
                        const checkOuter = opt.querySelector('.js-cart-edit-variation-check');
                        if (checkOuter) {
                            checkOuter.classList.toggle('border-[#B6F000]', active);
                            checkOuter.classList.toggle('border-[#D9D9D9]', !active);
                            const dot = checkOuter.firstElementChild;
                            if (dot) {
                                dot.classList.toggle('bg-[#B6F000]', active);
                                dot.classList.toggle('bg-[#D9D9D9]', !active);
                            }
                        }
                    });
                } break;
                case 'cart-edit-decrease-qty': {
                    event.preventDefault();
                    const wrap = clickElem.closest('.js-cart-edit-form');
                    const inp = wrap ? wrap.querySelector('.js-cart-edit-qty-input') : null;
                    if (!inp) return;
                    const next = Math.max(1, (parseInt(inp.value, 10) || 1) - 1);
                    inp.value = String(next);
                    corppixUpdateCartEditLinePrice(wrap);
                    const persToggle = wrap.querySelector('.js-cart-edit-personalization-toggle:checked');
                    const warn = wrap.querySelector('.js-cart-edit-personalization-min-qty');
                    if (warn && persToggle && persToggle.value === '1' && next < 3) warn.classList.remove('hidden');
                    else if (warn) warn.classList.add('hidden');
                } break;
                case 'cart-edit-increase-qty': {
                    event.preventDefault();
                    const wrap = clickElem.closest('.js-cart-edit-form');
                    const inp = wrap ? wrap.querySelector('.js-cart-edit-qty-input') : null;
                    if (!inp) return;
                    const next = (parseInt(inp.value, 10) || 1) + 1;
                    inp.value = String(next);
                    corppixUpdateCartEditLinePrice(wrap);
                    const persToggle = wrap.querySelector('.js-cart-edit-personalization-toggle:checked');
                    const warn = wrap.querySelector('.js-cart-edit-personalization-min-qty');
                    if (warn && persToggle && persToggle.value === '1' && next >= 3) warn.classList.add('hidden');
                } break;
                case 'cart-item-edit-submit': {
                    event.preventDefault();
                    const form = clickElem.closest('.js-cart-edit-form');
                    if (!form || typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;
                    const textErr = form.querySelector('.js-cart-edit-personalization-text-error');
                    const persOn = form.querySelector('.js-cart-edit-personalization-toggle:checked');
                    const textEl = form.querySelector('.js-cart-edit-personalization-text');
                    if (textErr) {
                        textErr.classList.add('hidden');
                        const defMsg = textErr.getAttribute('data-default-msg');
                        if (defMsg != null) textErr.textContent = defMsg;
                    }
                    if (persOn && persOn.value === '1' && textEl && !String(textEl.value || '').trim()) {
                        if (textErr) textErr.classList.remove('hidden');
                        textEl.focus();
                        return;
                    }
                    const fd = new FormData(form);
                    fd.append('action', 'corppix_cart_item_update');
					if ( var_from_php.is_checkout ) {
						fd.append( 'include_checkout_order_review_items', '1' );
					}
                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success && data.data) {
                                const cartInner = document.querySelector('.js-side-cart-inner');
                                if (cartInner && data.data.html) cartInner.innerHTML = data.data.html;
                                if (data.data.cart_count !== undefined) updateCartCountBadges(data.data.cart_count);
								if ( data.data.checkout_order_review_items_html !== undefined ) {
									const orderReviewItems = document.querySelector( '.js-checkout-order-review-cart-items' );
									if ( orderReviewItems ) {
										orderReviewItems.innerHTML = data.data.checkout_order_review_items_html;
									}
								}
								corppixApplyCheckoutSidebarFromAjaxData( data.data );
                                close_popups();
                            } else if (data && data.data && data.data.message && textErr) {
                                textErr.textContent = data.data.message;
                                textErr.classList.remove('hidden');
                                if (textEl) textEl.focus();
                            }
                        })
                        .catch(() => {});
                } break;
                case 'side-cart-remove-item': {
                    event.preventDefault();
                    const rmKey = clickElem.dataset.cartItemKey;
                    if (!rmKey) return;
                    postSideCartAction('corppix_side_cart_remove_item', { cart_item_key: rmKey });
                } break;
                case 'side-cart-qty-minus': {
                    event.preventDefault();
                    const k = clickElem.dataset.cartItemKey;
                    const wrap = clickElem.closest('.js-side-cart-qty-wrap');
                    const inp = wrap ? wrap.querySelector('.js-side-cart-qty-input') : null;
                    if (!k || !inp) return;
                    const minQty = corppixGetSideCartLineMinQty(inp);
                    const cur = parseInt(inp.value, 10) || 1;
                    if (cur <= minQty) return;
                    const next = cur - 1;
                    postSideCartAction('corppix_side_cart_update_qty', {
                        cart_item_key: k,
                        quantity: String(next),
                    });
                } break;
                case 'side-cart-qty-plus': {
                    event.preventDefault();
                    const k = clickElem.dataset.cartItemKey;
                    const wrap = clickElem.closest('.js-side-cart-qty-wrap');
                    const inp = wrap ? wrap.querySelector('.js-side-cart-qty-input') : null;
                    if (!k || !inp) return;
                    const next = (parseInt(inp.value, 10) || 1) + 1;
                    postSideCartAction('corppix_side_cart_update_qty', {
                        cart_item_key: k,
                        quantity: String(next),
                    });
                } break;
                case 'open-search': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-search-wrap');
                    if (!parent) return;
                    const inputWrap = parent.querySelector('.js-search-input-wrap');
                    const result = parent.querySelector('.js-search-result');
                    const searchInput = parent.querySelector('[data-role="header-site-search"]');
                    if (!inputWrap) return;

                    document.querySelectorAll('.js-search-input-wrap.open').forEach((panel) => {
                        if (panel === inputWrap) return;
                        panel.classList.remove('open');
                        const other = panel.closest('.js-search-wrap');
                        if (!other) return;
                        const oInp = other.querySelector('[data-role="header-site-search"]');
                        const oRes = other.querySelector('.js-search-result');
                        if (oInp) oInp.value = '';
                        if (oRes) oRes.innerHTML = '';
                    });

                    if (inputWrap.classList.contains('open')) {
                        inputWrap.classList.remove('open');
                        if (result) result.innerHTML = '';
                        if (searchInput) searchInput.value = '';
                    } else {
                        inputWrap.classList.add('open');
                        if (searchInput) {
                            searchInput.focus();
                        }
                    }
                } break;
                case 'close-menu':
                case 'open-mobile-menu': {
                    event.preventDefault();
                    const menu = document.querySelector('.js-site-menu');
                    const body = document.querySelector('body');
                    menu && menu.classList.toggle('hidden');
                    body && body.classList.toggle('menu-open');
                    
                } break;
                case 'mobile-contact-anchor': {
                    event.preventDefault();
                    const raw = event.target.getAttribute('href');
                    
                    if(raw) {
                        window.location.href = `${var_from_php.site_url}/${raw}`;
                    }
                    
                    const menu = document.querySelector('.js-site-menu');
                    const body = document.querySelector('body');
                    menu && menu.classList.add('hidden');
                    body && body.classList.remove('menu-open');
                } break;
                case 'add-to-cart': {
                    event.preventDefault();
                    const btn = clickElem;
                    if (btn.disabled) return;
                    const productId = btn.dataset.productId;
                    const variationId = btn.dataset.variationId || '0';
                    const qtyWrap = btn.closest('.w-full, .product-page') || document;
                    const qtyInput = qtyWrap.querySelector('.js-single-qty-input');
                    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
                    if (qtyInput) qtyInput.value = String(quantity);
                    const personalizationWrap = document.querySelector('.js-single-personalization');
                    const cartMsgEl = document.querySelector('.js-single-cart-message');
                    const setCartMessage = (text, isError) => {
                        if (!cartMsgEl) return;
                        cartMsgEl.textContent = text || '';
                        cartMsgEl.classList.toggle('hidden', !text);
                        cartMsgEl.classList.toggle('text-[#D9534F]', !!isError);
                        cartMsgEl.classList.toggle('text-[#2E7D32]', !isError && !!text);
                    };
                    setCartMessage('', false);
                    let personalizationEnabled = false;
                    if (personalizationWrap) {
                        const enabledRadio = personalizationWrap.querySelector('.js-personalization-toggle:checked');
                        personalizationEnabled = enabledRadio ? enabledRadio.value === '1' : false;
                    }
                    if (personalizationEnabled && quantity < 3) {
                        const msg = personalizationWrap ? personalizationWrap.querySelector('.js-personalization-min-qty') : null;
                        if (msg) msg.classList.remove('hidden');
                        setCartMessage('Персоналізація доступна від 3 шт.', true);
                        return;
                    }
                    const data = new FormData();
                    data.append('action', 'add_to_cart_ajax');
                    data.append('product_id', productId);
                    data.append('variation_id', variationId);
                    data.append('quantity', quantity);

                    if (personalizationWrap) {
                        const enabledRadio = personalizationWrap.querySelector('.js-personalization-toggle:checked');
                        const enabled = enabledRadio ? enabledRadio.value === '1' : false;
                        data.append('personalization_enabled', enabled ? '1' : '0');
                        if (enabled) {
                            const textEl = personalizationWrap.querySelector('.js-personalization-text');
                            const fileEl = personalizationWrap.querySelector('.js-personalization-file');
                            const placeRadio = personalizationWrap.querySelector('.js-personalization-place:checked');
                            const place = placeRadio ? placeRadio.value : '';
                            data.append('personalization_text', textEl ? (textEl.value || '').trim() : '');
                            data.append('personalization_place', place);
                            if (fileEl && fileEl.files && fileEl.files[0]) {
                                data.append('personalization_file', fileEl.files[0]);
                            }
                        } else {
                            data.append('personalization_text', '');
                            data.append('personalization_place', '');
                        }
                    }
                    btn.disabled = true;
                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: data
                    })
                    .then((res) => {
                        if (!res.ok) {
                            throw new Error(`HTTP ${res.status}`);
                        }
                        return res.json();
                    })
                    .then((response) => {
                        if (response.success) {
                            const count = response.data && response.data.cart_count;
                            if (count !== undefined) updateCartCountBadges(count);
                            refreshSideCartInner();
                            const okText =
                                (response.data && response.data.message) ||
                                'Товар додано в кошик.';
                            setCartMessage(okText, false);
                            if (btn.classList.contains('js-single-add-to-cart')) {
                                resetSingleProductAfterSuccessfulAddToCart(btn.closest('.product-page'));
                            }
                        } else {
                            const errText =
                                (response.data && response.data.message) ||
                                (typeof response.data === 'string' ? response.data : '') ||
                                t( 'cart_add_failed', 'Не вдалося додати товар в кошик.' );
                            setCartMessage(errText, true);
                        }
                    })
                    .catch(() => {
                        setCartMessage(
                            t( 'connection_error_refresh', 'Помилка з’єднання. Перевірте URL сайту в налаштуваннях WordPress або оновіть сторінку.' ),
                            true
                        );
                    })
                    .finally(() => { btn.disabled = false; });
                } break;
                case 'decrease-qty': {
                    event.preventDefault();
                    const wrap = clickElem.closest('.js-single-qty-wrap');
                    if (!wrap) return;
                    const input = wrap.querySelector('.js-single-qty-input');
                    if (!input) return;
                    const value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
                    input.value = String(value);
                } break;
                case 'increase-qty': {
                    event.preventDefault();
                    const wrap = clickElem.closest('.js-single-qty-wrap');
                    if (!wrap) return;
                    const input = wrap.querySelector('.js-single-qty-input');
                    if (!input) return;
                    const value = (parseInt(input.value, 10) || 1) + 1;
                    input.value = String(value);
                } break;
                case 'toggle-read-more': {
                    event.preventDefault();
                    const wrap = clickElem.closest('.js-read-more-wrap');
                    const icon = wrap ? wrap.querySelector('.js-read-more-icon') : null;
                    if (wrap) wrap.classList.toggle('is-expanded');
                    if (icon) icon.classList.toggle('rotate-180');
                } break;
                case 'play-slide-video': {
                    event.preventDefault();
                    
                    const videoUrl = clickElem.dataset.url;
                    if (!videoUrl) return;

                    const wrapper = clickElem.closest('.js-video-wrapper');
                    if (!wrapper) return;

                    // Make sure wrapper can position absolutely placed video
                    wrapper.style.position = wrapper.style.position || 'relative';

                    // Hide play button itself
                    clickElem.style.display = 'none';

                    const preview = wrapper.querySelector('.js-video-image');
                    if (preview) {
                        preview.style.display = 'none';
                    }

                    let videoEl = wrapper.querySelector('video');
                    if (!videoEl) {
                        videoEl = document.createElement('video');
                        videoEl.src = videoUrl;
                        videoEl.className = 'block w-full h-full object-cover';
                        videoEl.setAttribute('playsinline', '');
                        videoEl.setAttribute('webkit-playsinline', '');
                        wrapper.appendChild(videoEl);
                    } else {
                        if (videoEl.src !== videoUrl) {
                            videoEl.src = videoUrl;
                        }
                    }

                    // Always apply correct styles (video might already exist)
                    videoEl.style.position = 'absolute';
                    videoEl.style.top = '0';
                    videoEl.style.left = '0';
                    videoEl.style.width = '100%';
                    videoEl.style.height = '100%';
                    videoEl.style.objectFit = 'cover';
                    videoEl.style.display = 'block';
                    videoEl.autoplay = true;
                    videoEl.muted = true;
                    videoEl.controls = true;

                    videoEl.play().catch(() => {});
                } break;
                case 'select-color': {
                    event.preventDefault();
                    const swatch = clickElem;
                    const variationId = swatch.dataset.variationId;
                    if (!variationId) return;
                    const card = swatch.closest('.js-product-card');
                    if (!card) return;
                    const addBtn = card.querySelector('[data-role="add-to-cart"]');
                    if (!addBtn) return;
                    card.querySelectorAll('.js-color-swatch').forEach(s => s.classList.remove('active', 'border-[#532F72]'));
                    swatch.classList.add('active', 'border-[#532F72]');
                    addBtn.dataset.variationId = variationId;
                    addBtn.disabled = false;

                    const colorHint = card.querySelector('.js-product-card-color-hint');
                    if (colorHint) {
                        colorHint.classList.add('opacity-0', 'pointer-events-none');
                        colorHint.classList.remove('opacity-100');
                        colorHint.setAttribute('aria-hidden', 'true');
                    }

                    const img = card.querySelector('.js-product-card-image');
                    const priceEl = card.querySelector('.js-product-card-price');
                    if (img && swatch.dataset.variationImage) img.src = swatch.dataset.variationImage;
                    if (priceEl && swatch.dataset.variationPriceHtml) priceEl.innerHTML = swatch.dataset.variationPriceHtml;
                } break;
                case 'select-single-variation-color': {
                    event.preventDefault();
                    const option = clickElem;
                    const wrap = option.closest('.js-single-product-variation-colors');
                    if (!wrap) return;

                    const variationId = option.dataset.variationId || '';
                    const imageId = option.dataset.imageId || '';
                    const priceHtml = option.dataset.priceHtml || '';

                    wrap.querySelectorAll('.js-single-variation-option').forEach(item => {
                        item.classList.remove('border-[#B6F000]', 'shadow-[0_0_0_1px_#B6F000_inset]');
                        item.classList.add('border-[#D9D9D9]');
                        const radio = item.querySelector('.js-single-variation-radio');
                        if (radio) radio.checked = false;
                        const checkWrap = item.querySelector('.js-single-variation-check');
                        const checkDot = checkWrap ? checkWrap.querySelector('span') : null;
                        if (checkWrap) {
                            checkWrap.classList.remove('border-[#B6F000]');
                            checkWrap.classList.add('border-[#D9D9D9]');
                        }
                        if (checkDot) {
                            checkDot.classList.remove('bg-[#B6F000]');
                            checkDot.classList.add('bg-[#D9D9D9]');
                        }
                    });

                    option.classList.add('border-[#B6F000]', 'shadow-[0_0_0_1px_#B6F000_inset]');
                    option.classList.remove('border-[#D9D9D9]');
                    const ownRadio = option.querySelector('.js-single-variation-radio');
                    if (ownRadio) ownRadio.checked = true;
                    const ownCheckWrap = option.querySelector('.js-single-variation-check');
                    const ownCheckDot = ownCheckWrap ? ownCheckWrap.querySelector('span') : null;
                    if (ownCheckWrap) {
                        ownCheckWrap.classList.add('border-[#B6F000]');
                        ownCheckWrap.classList.remove('border-[#D9D9D9]');
                    }
                    if (ownCheckDot) {
                        ownCheckDot.classList.add('bg-[#B6F000]');
                        ownCheckDot.classList.remove('bg-[#D9D9D9]');
                    }

                    const priceEl = document.querySelector('.js-single-product-price');
                    if (priceEl && priceHtml) {
                        priceEl.innerHTML = priceHtml;
                    }

                    const variationInput = document.querySelector('.js-single-selected-variation-id');
                    if (variationInput) {
                        variationInput.value = variationId;
                    }

                    const addBtn = document.querySelector('.js-single-add-to-cart');
                    if (addBtn) {
                        addBtn.dataset.variationId = variationId || '0';
                        addBtn.disabled = !variationId;
                    }

                    const qSource = document.querySelector('.js-single-quick-order-source');
                    if (qSource && option.dataset.variationDisplayName) {
                        qSource.dataset.currentDisplayName = option.dataset.variationDisplayName;
                    }

                    if (imageId) {
                        document.querySelectorAll('.js-product-gallery-main').forEach((mainGalleryEl) => {
                            slideProductMainGalleryToAttachment(mainGalleryEl, imageId);
                        });
                    }
                } break;
                case 'play-steel-video': {
                    event.preventDefault();
                    
                    const videoUrl = clickElem.dataset.url;
                    if (!videoUrl) return;

                    const wrapper = clickElem.closest('.js-video-wrapper');
                    if (!wrapper) return;

                    wrapper.style.position = wrapper.style.position || 'relative';

                    // Hide play button
                    clickElem.style.display = 'none';

                    // Hide preview image inside wrapper (if есть)
                    const previewImg = wrapper.querySelector('img');
                    if (previewImg) {
                        previewImg.style.display = 'none';
                    }

                    let videoEl = wrapper.querySelector('video');
                    if (!videoEl) {
                        videoEl = document.createElement('video');
                        videoEl.src = videoUrl;
                        videoEl.className = 'block w-full h-full object-cover';
                        videoEl.setAttribute('playsinline', '');
                        videoEl.setAttribute('webkit-playsinline', '');
                        wrapper.appendChild(videoEl);
                    } else {
                        if (videoEl.src !== videoUrl) {
                            videoEl.src = videoUrl;
                        }
                    }

                    videoEl.style.position = 'absolute';
                    videoEl.style.top = '0';
                    videoEl.style.left = '0';
                    videoEl.style.width = '100%';
                    videoEl.style.height = '100%';
                    videoEl.style.objectFit = 'cover';
                    videoEl.style.display = 'block';
                    videoEl.autoplay = true;
                    videoEl.muted = true;
                    videoEl.controls = true;

                    videoEl.play().catch(() => {});
                } break;
                case 'play-article-video': {
                    event.preventDefault();

                    const videoUrl = clickElem.dataset.url;
                    const wrapper = clickElem.closest( '.js-article-video' );
                    const preview = wrapper ? wrapper.querySelector( '.js-article-video-preview' ) : null;

                    if ( ! videoUrl || ! wrapper || ! preview ) return;

                    let videoEl = wrapper.querySelector( 'video' );

                    if ( ! videoEl ) {
                        videoEl = document.createElement( 'video' );
                        videoEl.className = 'article-video__video absolute inset-0 block h-full w-full object-cover';
                        videoEl.setAttribute( 'playsinline', '' );
                        videoEl.setAttribute( 'webkit-playsinline', '' );
                        videoEl.setAttribute( 'controls', '' );
                        videoEl.src = videoUrl;
                        wrapper.appendChild( videoEl );
                    }

                    preview.classList.add( 'hidden' );
                    videoEl.hidden = false;
                    videoEl.controls = true;
                    videoEl.play().catch( () => {
                        preview.classList.remove( 'hidden' );
                        videoEl.hidden = true;
                    } );
                } break;
                case 'open-filter': {
                    event.preventDefault();
                    const filters = document.querySelectorAll('.js-filter-val');
                    filters && filters.forEach( item => {
                        $(item).slideUp();
                    })
                    
                    const parent = clickElem.closest('.js-filter');
                    if(!parent) return;
                    const filter = parent.querySelector('.js-filter-val');
                    if(!filter) return;
                    if ($(filter).is(':visible')) {
                        $(filter).slideUp();
                    } else {
                        $(filter).slideDown();
                    }
                } break;
                case 'remove-filter': {
                    event.preventDefault();
                    const filters = document.querySelectorAll('.js-filter-val');
                    filters && filters.forEach( item => { $(item).slideUp(); } );
                    const chip = clickElem.closest('.filter-chip');
                    if (!chip) return;
                    const form = document.querySelector('[data-role="filter-product"]');
                    if (!form) return;
                    const type = chip.dataset.filterType;
                    const value = chip.dataset.filterValue;
                    if (type === 'price') {
                        const priceFrom = form.querySelector('input[name="price-from"]');
                        const priceTo = form.querySelector('input[name="price-to"]');
                        if (priceFrom) priceFrom.value = '';
                        if (priceTo) priceTo.value = '';
                    } else if (type === 'color') {
                        const cb = form.querySelector(`input[name="color[]"][value="${CSS.escape(value)}"]`);
                        if (cb) cb.checked = false;
                    } else if (type === 'model') {
                        const cb = form.querySelector(`input[name="model[]"][value="${CSS.escape(value)}"]`);
                        if (cb) cb.checked = false;
                    } else if (type === 'sort') {
                        const radio = form.querySelector(`input[name="sort"][value="${value}"]`);
                        if (radio) radio.checked = false;
                    }
                    if (typeof updateCheckedFilters === 'function') updateCheckedFilters();
                    if (typeof loadFilteredProducts === 'function') loadFilteredProducts(1);
                } break;
			}
		} );

		// Close filter dropdowns when clicking outside
		document.addEventListener( 'click', event => {
			if ( event.target.closest( '.js-filter' ) ) return;
			const filters = document.querySelectorAll( '.js-filter-val' );
			filters && filters.forEach( item => { $( item ).slideUp(); } );
		} );

		const headerSearchDebounced = new WeakMap();
		function corppixHeaderSiteSearchAjax( inputEl ) {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.ajax_url ) {
				return;
			}
			const wrap = inputEl.closest( '.js-search-wrap' );
			if ( ! wrap ) {
				return;
			}
			const resultsEl = wrap.querySelector( '.js-search-result' );
			if ( ! resultsEl ) {
				return;
			}
			const q = ( inputEl.value || '' ).trim();
			if ( ! q ) {
				resultsEl.innerHTML = '';
				return;
			}
			const fd = new FormData();
			fd.append( 'action', 'ajax_search' );
			fd.append( 'search', q );
			resultsEl.innerHTML = `<p class="px-[14px] py-[10px] text-[13px] font-2 text-[#848484] m-0">${t( 'loading_ellipsis', 'Завантаження…' )}</p>`;
			fetch( var_from_php.ajax_url, { method: 'POST', credentials: 'same-origin', body: fd } )
				.then( ( r ) => r.json() )
				.then( ( data ) => {
					if ( ! inputEl.isConnected ) {
						return;
					}
					if ( data.success && data.data && data.data.html ) {
						resultsEl.innerHTML = data.data.html;
					} else {
						resultsEl.innerHTML = `<p class="px-[14px] py-[10px] text-[13px] font-2 text-[#848484] m-0">${t( 'nothing_found', 'Нічого не знайдено' )}</p>`;
					}
				} )
				.catch( () => {
					if ( resultsEl && inputEl.isConnected ) {
						resultsEl.innerHTML = '';
					}
				} );
		}

		document.body.addEventListener( 'click', ( event ) => {
			if ( event.target.closest( '.js-search-wrap' ) ) {
				return;
			}
			document.querySelectorAll( '.js-search-input-wrap.open' ).forEach( ( panel ) => {
				panel.classList.remove( 'open' );
				const wrap = panel.closest( '.js-search-wrap' );
				if ( ! wrap ) {
					return;
				}
				const inp = wrap.querySelector( '[data-role="header-site-search"]' );
				const res = wrap.querySelector( '.js-search-result' );
				if ( inp ) {
					inp.value = '';
				}
				if ( res ) {
					res.innerHTML = '';
				}
			} );
		} );
       
       /* Add global handler for input event*/
		document.body.addEventListener( 'input', event => {
			const target = event.target;
			if ( target && target.matches && target.matches( 'input[type="checkbox"][data-role="quick-order-accept"]' ) ) {
				const form = target.closest( 'form[data-role="quick-order"]' );
				const submitBtn = form ? form.querySelector( '.js-quick-order-submit' ) : null;
				if ( submitBtn ) {
					submitBtn.disabled = !target.checked;
				}
			}
			const ROLE = target && target.dataset ? target.dataset.role : null;
			if ( !ROLE ) return;
			switch ( ROLE ) {
				case 'change-filter':
					updateCheckedFilters();
					debouncedLoadFilter();
					break;
				case 'search-product':
					event.preventDefault();
					break;
				case 'header-site-search': {
					let d = headerSearchDebounced.get( target );
					if ( ! d ) {
						d = debounce( () => {
							corppixHeaderSiteSearchAjax( target );
						}, 1000 );
						headerSearchDebounced.set( target, d );
					}
					d();
				} break;
			}
		});
        
        /* Add global handler for change event*/
		document.body.addEventListener( 'change', event => {
			const target = event.target;
			const ROLE = target && target.dataset ? target.dataset.role : null;

			if ( ROLE === 'quick-order-accept' && target.matches && target.matches( 'input[type="checkbox"]' ) ) {
				const form = target.closest( 'form[data-role="quick-order"]' );
				const submitBtn = form ? form.querySelector( '.js-quick-order-submit' ) : null;
    
				if ( submitBtn ) {
					submitBtn.disabled = !target.checked;
				}
			}

			if ( !ROLE ) return;
			switch ( ROLE ) {
				case 'change-filter':
					updateCheckedFilters();
					if ( window.corppixSkipNextSortChangeLoad && target.matches && target.matches( 'input[name="sort"]' ) ) {
						window.corppixSkipNextSortChangeLoad = false;
						break;
					}
					if (typeof loadFilteredProducts === 'function') loadFilteredProducts(1);
					break;
				case 'checkout-delivery-type': {
					if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
						break;
					}
					if ( typeof window.corppixNpOnDeliveryTypeChange === 'function' ) {
						window.corppixNpOnDeliveryTypeChange( event );
					}
					const deliverySummaryEl = document.querySelector( '.js-checkout-summary-delivery-method' );
					if ( deliverySummaryEl && target && target.getAttribute ) {
						const deliveryTitle = target.getAttribute( 'data-title' );
						if ( deliveryTitle ) {
							deliverySummaryEl.textContent = deliveryTitle;
						}
					}
					const formCheckout = target.closest ? target.closest( 'form.checkout' ) : null;
					const cityAfterType = formCheckout ? formCheckout.querySelector( '[data-role="np-city-select"]' ) : null;
					checkoutSyncDeliveryCitySummary( cityAfterType );
					const whAfterType = formCheckout ? formCheckout.querySelector( '[data-role="np-warehouse-select"]' ) : null;
					checkoutSyncDeliveryWarehouseSummary( whAfterType );
					checkoutSyncNpPointSummaryLabel( target.value );
					checkoutSyncDeliverySummaryAddressRows( target.value );
					checkoutSyncAllCourierSummaryFields( formCheckout );
				} break;
				case 'np-city-select': {
					if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
						break;
					}
					checkoutSyncDeliveryCitySummary( target );
				} break;
				case 'np-warehouse-select': {
					if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
						break;
					}
					checkoutSyncDeliveryWarehouseSummary( target );
				} break;
				case 'checkout-payment-type': {
					if ( typeof var_from_php === 'undefined' || ! var_from_php.is_checkout ) {
						break;
					}
					checkoutSyncPaymentMethodSummary( target );
				} break;
				case 'checkout-recipient-type': {
					if ( typeof window.corppixCheckoutSyncRecipientOtherFields === 'function' ) {
						window.corppixCheckoutSyncRecipientOtherFields();
					}
				} break;
			}
		} );
        
        document.querySelectorAll('.js-single-personalization').forEach((wrap) => {
            const checked = wrap.querySelector('.js-personalization-toggle:checked');
            const enabled = !!(checked && checked.value === '1');
            syncSingleProductPersonalizationUi(wrap, enabled);
        });

        // Single product personalization toggle
        document.body.addEventListener('change', (event) => {
            const target = event.target;
            if (!target || !target.classList || !target.classList.contains('js-personalization-toggle')) return;
            const wrap = target.closest('.js-single-personalization');
            if (!wrap) return;
            const minMsg = wrap.querySelector('.js-personalization-min-qty');
            if (minMsg) minMsg.classList.add('hidden');
            const enabled = target.value === '1';
            syncSingleProductPersonalizationUi(wrap, enabled);
        });

        document.body.addEventListener('change', (event) => {
            const target = event.target;
            if (!target || !target.classList || !target.classList.contains('js-personalization-file')) return;
            const wrap = target.closest('.js-single-personalization');
            if (!wrap) return;
            const preview = wrap.querySelector('.js-personalization-file-preview');
            const img = preview ? preview.querySelector('.js-personalization-file-preview-img') : null;
            if (!preview || !img) return;

            clearPersonalizationFilePreview(wrap);

            const file = target.files && target.files[0];
            if (!file) return;
            if (!file.type || !file.type.startsWith('image/')) {
                target.value = '';
                return;
            }
            const url = URL.createObjectURL(file);
            preview.dataset.blobUrl = url;
            img.src = url;
            img.alt = file.name || '';
            preview.classList.remove('hidden');
        });

        document.body.addEventListener('click', (event) => {
            const btn = event.target.closest('.js-personalization-file-remove');
            if (!btn) return;
            event.preventDefault();
            const wrap = btn.closest('.js-single-personalization');
            if (!wrap) return;
            removePersonalizationSelectedFile(wrap);
        });

		document.body.addEventListener( 'submit', async (event) => {
			const ROLE = event.target.dataset.role;
			const submitElem = event.target;

			if ( !ROLE ) return;

			switch ( ROLE ) {
				case 'subscribe-form': {
					event.preventDefault();
					const form = submitElem;
					const emailInput = form.querySelector( '.js-subscribe-email' );
					const submitButton = form.querySelector( '.js-subscribe-submit' );
					const messageElement = form.querySelector( '.js-subscribe-message' );
					const email = ( emailInput ? emailInput.value : '' ).trim();
					const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					const setSubscribeMessage = ( message, isError ) => {
						if ( ! messageElement ) return;
						messageElement.textContent = message || '';
						messageElement.classList.toggle( 'hidden', ! message );
						messageElement.classList.toggle( 'text-[#D9534F]', !! isError );
						messageElement.classList.toggle( 'text-green', ! isError && !! message );
					};

					setSubscribeMessage( '', false );
					if ( ! email || ! emailPattern.test( email ) ) {
						setSubscribeMessage( t( 'form_email_invalid', 'Вкажіть коректний e-mail.' ), true );
						if ( emailInput ) emailInput.focus();
						return;
					}

					if ( typeof var_from_php !== 'undefined' && var_from_php.turnstile_site_key ) {
						try {
							if ( submitButton ) submitButton.disabled = true;
							await window.corppixTurnstileGetToken( form );
						} catch ( error ) {
							setSubscribeMessage( t( 'form_turnstile_failed', 'Не вдалося пройти перевірку. Спробуйте ще раз.' ), true );
							if ( submitButton ) submitButton.disabled = false;
							return;
						}
					}

					if ( typeof var_from_php === 'undefined' || ! var_from_php.ajax_url ) return;
					const formData = new FormData( form );
					formData.append( 'action', 'corppix_subscribe_form_submit' );
					if ( submitButton ) submitButton.disabled = true;

					fetch( var_from_php.ajax_url, {
						method: 'POST',
						credentials: 'same-origin',
						body: formData,
					} )
						.then( response => response.json() )
						.then( data => {
							if ( data.success ) {
								form.reset();
								if ( typeof window.corppixTurnstileResetForm === 'function' ) {
									window.corppixTurnstileResetForm( form );
								}
								setSubscribeMessage( data.data && data.data.message ? data.data.message : 'OK', false );
								return;
							}
							setSubscribeMessage( data.data && data.data.message ? data.data.message : t( 'form_submit_error', 'Помилка відправки. Спробуйте пізніше.' ), true );
						} )
						.catch( () => setSubscribeMessage( t( 'form_network_error', 'Помилка мережі. Спробуйте пізніше.' ), true ) )
						.finally( () => {
							if ( submitButton ) submitButton.disabled = false;
						} );
				} break;
                case 'main-form': {
                    event.preventDefault();
                    const form = submitElem;
                    const msgEl = form.querySelector('.js-main-form-message');
                    const btn = form.querySelector('.js-main-form-submit');
                    const emailInp = form.querySelector('.js-main-form-email');
                    const nameInp = form.querySelector('.js-main-form-name');
					const turnstileToken = form.querySelector('input[name="cf-turnstile-response"]');

                    const setMsg = (text, isError) => {
                        if (!msgEl) return;
                        msgEl.textContent = text || '';
                        msgEl.classList.toggle('hidden', !text);
                        msgEl.classList.toggle('text-[#D9534F]', !!isError);
                        msgEl.classList.toggle('text-[#B6F000]', !isError && !!text);
                    };
                    setMsg('', false);

                    const email = (emailInp?.value || '').trim();
                    const name = (nameInp?.value || '').trim();

                    if (name.length < 2) {
                        setMsg( t( 'form_name_min2', 'Вкажіть ім’я (мінімум 2 символи).' ), true );
                        nameInp?.focus();
                        return;
                    }
                    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!email || !emailRe.test(email)) {
                        setMsg( t( 'form_email_invalid', 'Вкажіть коректний e-mail.' ), true );
                        emailInp?.focus();
                        return;
                    }
					if (typeof var_from_php !== 'undefined' && var_from_php.turnstile_site_key) {
						try {
							if (btn) btn.disabled = true;
							await window.corppixTurnstileGetToken(form);
						} catch (e) {
							setMsg( t( 'form_turnstile_failed', 'Не вдалося пройти перевірку. Спробуйте ще раз.' ), true );
							if (btn) btn.disabled = false;
							return;
						}
					}

                    if (typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;

                    const fd = new FormData(form);
                    fd.append('action', 'corppix_main_form_submit');
                    if (btn) btn.disabled = true;

                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success) {
                                form.reset();
								if (typeof window.corppixTurnstileResetForm === 'function') {
									window.corppixTurnstileResetForm(form);
								}
                                setMsg('', false);
                                if (typeof window.corppixOpenPopupById === 'function') {
                                    window.corppixOpenPopupById('main_form_success_popup');
                                }
                            } else {
                                const m = data.data && data.data.message ? data.data.message : t( 'form_submit_error', 'Помилка відправки. Спробуйте пізніше.' );
                                setMsg(m, true);
                            }
                        })
                        .catch(() => {
                            setMsg( t( 'form_network_error', 'Помилка мережі. Спробуйте пізніше.' ), true );
                        })
                        .finally(() => {
                            if (btn) btn.disabled = false;
                        });
                } break;
                case 'benefits-form': {
                    event.preventDefault();
                    const form = submitElem;
                    const msgEl = form.querySelector('.js-benefits-form-message');
                    const btn = form.querySelector('.js-benefits-form-submit');
                    const emailInp = form.querySelector('.js-benefits-form-email');
                    const nameInp = form.querySelector('.js-benefits-form-name');
                    const telInp = form.querySelector('.js-benefits-form-tel');
					const turnstileToken = form.querySelector('input[name="cf-turnstile-response"]');

                    const setMsg = (text, isError) => {
                        if (!msgEl) return;
                        msgEl.textContent = text || '';
                        msgEl.classList.toggle('hidden', !text);
                        msgEl.classList.toggle('text-[#D9534F]', !!isError);
                        msgEl.classList.toggle('text-[#B6F000]', !isError && !!text);
                    };
                    setMsg('', false);

                    const email = (emailInp?.value || '').trim();
                    const name = (nameInp?.value || '').trim();
                    const tel = (telInp?.value || '').trim();

                    if (name.length < 2) {
                        setMsg( t( 'form_name_min2', 'Вкажіть ім’я (мінімум 2 символи).' ), true );
                        nameInp?.focus();
                        return;
                    }
                    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!email || !emailRe.test(email)) {
                        setMsg( t( 'form_email_invalid', 'Вкажіть коректний e-mail.' ), true );
                        emailInp?.focus();
                        return;
                    }
                    if (!tel) {
                        setMsg( t( 'form_phone_required', 'Вкажіть номер телефону.' ), true );
                        telInp?.focus();
                        return;
                    }
                    const telDigits = tel.replace(/\D/g, '');
                    if (telDigits.length < 9) {
                        setMsg( t( 'form_phone_invalid_min9', 'Вкажіть коректний номер телефону (мінімум 9 цифр).' ), true );
                        telInp?.focus();
                        return;
                    }
					if (typeof var_from_php !== 'undefined' && var_from_php.turnstile_site_key) {
						try {
							if (btn) btn.disabled = true;
							await window.corppixTurnstileGetToken(form);
						} catch (e) {
							setMsg( t( 'form_turnstile_failed', 'Не вдалося пройти перевірку. Спробуйте ще раз.' ), true );
							if (btn) btn.disabled = false;
							return;
						}
					}

                    if (typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;

                    const fd = new FormData(form);
                    fd.append('action', 'corppix_benefits_form_submit');
                    if (btn) btn.disabled = true;

                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success) {
                                form.reset();
								if (typeof window.corppixTurnstileResetForm === 'function') {
									window.corppixTurnstileResetForm(form);
								}
                                setMsg('', false);
                                if (typeof window.corppixOpenPopupById === 'function') {
                                    window.corppixOpenPopupById('main_form_success_popup');
                                }
                            } else {
                                const m = data.data && data.data.message ? data.data.message : t( 'form_submit_error', 'Помилка відправки. Спробуйте пізніше.' );
                                setMsg(m, true);
                            }
                        })
                        .catch(() => {
                            setMsg( t( 'form_network_error', 'Помилка мережі. Спробуйте пізніше.' ), true );
                        })
                        .finally(() => {
                            if (btn) btn.disabled = false;
                        });
                } break;
                case 'form-order': {
                    event.preventDefault();
                    const form = submitElem;
                    const msgEl = form.querySelector('.js-form-order-message');
                    const btn = form.querySelector('[data-role="form-order-submit"]') || form.querySelector('.js-form-order-submit');
                    const nameInp = form.querySelector('.js-form-order-name');
                    const phoneInp = form.querySelector('.js-form-order-phone');
                    const confirmChk = form.querySelector('[data-role="form-order-consent"]') || form.querySelector('.js-contact-form-confirm');
					const turnstileToken = form.querySelector('input[name="cf-turnstile-response"]');

                    const setMsg = (text, isError) => {
                        if (!msgEl) return;
                        msgEl.textContent = text || '';
                        msgEl.classList.toggle('hidden', !text);
                        msgEl.classList.toggle('text-[#D9534F]', !!isError);
                        msgEl.classList.toggle('text-[#B6F000]', !isError && !!text);
                    };
                    setMsg('', false);

                    const name = (nameInp?.value || '').trim();
                    const phone = (phoneInp?.value || '').trim();

                    if (name.length < 2) {
                        setMsg( t( 'form_name_min2', 'Вкажіть ім’я (мінімум 2 символи).' ), true );
                        nameInp?.focus();
                        return;
                    }
                    if (!phone) {
                        setMsg( t( 'form_phone_required', 'Вкажіть номер телефону.' ), true );
                        phoneInp?.focus();
                        return;
                    }
                    const telDigits = phone.replace(/\D/g, '');
                    if (telDigits.length < 9) {
                        setMsg( t( 'form_phone_invalid_min9', 'Вкажіть коректний номер телефону (мінімум 9 цифр).' ), true );
                        phoneInp?.focus();
                        return;
                    }
					if (!confirmChk || !confirmChk.checked) {
						setMsg( t( 'form_consent_required', 'Підтвердіть згоду на обробку даних.' ), true );
						confirmChk?.focus();
						return;
					}
					if (typeof var_from_php !== 'undefined' && var_from_php.turnstile_site_key) {
						try {
							if (btn) btn.disabled = true;
							await window.corppixTurnstileGetToken(form);
						} catch (e) {
							setMsg( t( 'form_turnstile_failed', 'Не вдалося пройти перевірку. Спробуйте ще раз.' ), true );
							if (btn) btn.disabled = !(confirmChk && confirmChk.checked);
							return;
						}
					}

                    if (typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;

                    const fd = new FormData(form);
                    fd.append('action', 'corppix_form_order_submit');
                    if (btn) btn.disabled = true;

                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success) {
                                form.reset();
								if (confirmChk) confirmChk.checked = false;
								if (btn) btn.disabled = true;
								if (typeof window.corppixTurnstileResetForm === 'function') {
									window.corppixTurnstileResetForm(form);
								}
                                setMsg('', false);
                                if (typeof window.corppixOpenPopupById === 'function') {
                                    window.corppixOpenPopupById('main_form_success_popup');
                                }
                            } else {
                                const m = data.data && data.data.message ? data.data.message : t( 'form_submit_error', 'Помилка відправки. Спробуйте пізніше.' );
                                setMsg(m, true);
                            }
                        })
                        .catch(() => {
                            setMsg( t( 'form_network_error', 'Помилка мережі. Спробуйте пізніше.' ), true );
                        })
                        .finally(() => {
                            if (btn) btn.disabled = !(confirmChk && confirmChk.checked);
                        });
                } break;
                case 'quick-order': {
                    event.preventDefault();
                    const form = submitElem;
                    const msgEl = form.querySelector('.js-quick-order-message');
                    const btn = form.querySelector('.js-quick-order-submit');
                    const acceptCb = form.querySelector('[data-role="quick-order-accept"]');
                    const nameInp = form.querySelector('.js-quick-order-name');
                    const phoneInp = form.querySelector('.js-quick-order-phone');
                    const commentInp = form.querySelector('.js-quick-order-comment');

                    const setMsg = (text, isError) => {
                        if (!msgEl) return;
                        msgEl.textContent = text || '';
                        msgEl.classList.toggle('hidden', !text);
                        msgEl.classList.toggle('text-[#D9534F]', !!isError);
                        msgEl.classList.toggle('text-[#B6F000]', !isError && !!text);
                    };
                    setMsg('', false);

                    if (!acceptCb || !acceptCb.checked) {
                        setMsg( t( 'form_consent_personal', 'Підтвердіть згоду на обробку персональних даних.' ), true );
                        acceptCb?.focus();
                        return;
                    }

                    const name = (nameInp?.value || '').trim();
                    const phone = (phoneInp?.value || '').trim();
                    const comment = (commentInp?.value || '').trim();

                    if (name.length < 2) {
                        setMsg( t( 'form_name_min2', 'Вкажіть ім’я (мінімум 2 символи).' ), true );
                        nameInp?.focus();
                        return;
                    }
                    if (!phone) {
                        setMsg( t( 'form_phone_required', 'Вкажіть номер телефону.' ), true );
                        phoneInp?.focus();
                        return;
                    }
                    const telDigits = phone.replace(/\D/g, '');
                    if (telDigits.length < 9) {
                        setMsg( t( 'form_phone_invalid_min9', 'Вкажіть коректний номер телефону (мінімум 9 цифр).' ), true );
                        phoneInp?.focus();
                        return;
                    }
                    if (comment.length > 2000) {
                        setMsg( t( 'form_comment_too_long', 'Коментар занадто довгий.' ), true );
                        commentInp?.focus();
                        return;
                    }

                    const pidParent = (form.querySelector('.js-quick-order-parent-product-id')?.value || '').trim();
                    const pidLine = (form.querySelector('.js-quick-order-product-id')?.value || '').trim();
                    const pName = (form.querySelector('.js-quick-order-product-name')?.value || '').trim();
                    if (!pidParent || !pidLine || !pName) {
                        setMsg( t( 'form_open_from_product', 'Відкрийте швидке замовлення зі сторінки товару.' ), true );
                        return;
                    }

                    if (typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;

                    const fd = new FormData(form);
                    fd.append('action', 'corppix_quick_order_submit');
                    if (btn) btn.disabled = true;

                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success) {
                                form.reset();
                                form.querySelector('.js-quick-order-product-id') && (form.querySelector('.js-quick-order-product-id').value = '');
                                form.querySelector('.js-quick-order-parent-product-id') && (form.querySelector('.js-quick-order-parent-product-id').value = '');
                                form.querySelector('.js-quick-order-product-name') && (form.querySelector('.js-quick-order-product-name').value = '');
                                if (acceptCb) acceptCb.checked = false;
                                if (btn) btn.disabled = true;
                                setMsg('', false);
                                if (typeof window.corppixOpenPopupById === 'function') {
                                    window.corppixOpenPopupById('quick-order-success');
                                }
                            } else {
                                const m = data.data && data.data.message ? data.data.message : t( 'form_submit_error', 'Помилка відправки. Спробуйте пізніше.' );
                                setMsg(m, true);
                            }
                        })
                        .catch(() => {
                            setMsg( t( 'form_network_error', 'Помилка мережі. Спробуйте пізніше.' ), true );
                        })
                        .finally(() => {
                            if (btn && acceptCb && acceptCb.checked) btn.disabled = false;
                        });
                } break;
                case 'contact-form-order': {
                    event.preventDefault();
                    const form = submitElem;
                    const msgEl = form.querySelector('.js-contact-form-message');
                    const btn = form.querySelector('[data-role="contact-submit"]') || form.querySelector('.js-contact-form-submit');
                    const nameInp = form.querySelector('.js-contact-form-name');
                    const phoneInp = form.querySelector('.js-contact-form-phone');
                    const modelSel = form.querySelector('.js-contact-form-model');
                    const confirmChk = form.querySelector('[data-role="contact-consent"]') || form.querySelector('.js-contact-form-confirm');
					const turnstileToken = form.querySelector('input[name="cf-turnstile-response"]');

                    const setMsg = (text, isError) => {
                        if (!msgEl) return;
                        msgEl.textContent = text || '';
                        msgEl.classList.toggle('hidden', !text);
                        msgEl.classList.toggle('text-[#D9534F]', !!isError);
                        msgEl.classList.toggle('text-[#B6F000]', !isError && !!text);
                    };
                    setMsg('', false);

                    const name = (nameInp?.value || '').trim();
                    const phone = (phoneInp?.value || '').trim();
                    const model = (modelSel?.value || '').trim();

                    if (name.length < 2) {
                        setMsg( t( 'form_name_min2', 'Вкажіть ім’я (мінімум 2 символи).' ), true );
                        nameInp?.focus();
                        return;
                    }
                    if (!phone) {
                        setMsg( t( 'form_phone_required', 'Вкажіть номер телефону.' ), true );
                        phoneInp?.focus();
                        return;
                    }
                    const telDigits = phone.replace(/\D/g, '');
                    if (telDigits.length < 9) {
                        setMsg( t( 'form_phone_invalid_min9', 'Вкажіть коректний номер телефону (мінімум 9 цифр).' ), true );
                        phoneInp?.focus();
                        return;
                    }
                    if (!model) {
                        setMsg( t( 'form_choose_model', 'Оберіть модель.' ), true );
                        modelSel?.focus();
                        return;
                    }
                    if (!confirmChk || !confirmChk.checked) {
                        setMsg( t( 'form_consent_required', 'Підтвердіть згоду на обробку даних.' ), true );
                        confirmChk?.focus();
                        return;
                    }
					if (typeof var_from_php !== 'undefined' && var_from_php.turnstile_site_key) {
						try {
							if (btn) btn.disabled = true;
							await window.corppixTurnstileGetToken(form);
						} catch (e) {
							setMsg( t( 'form_turnstile_failed', 'Не вдалося пройти перевірку. Спробуйте ще раз.' ), true );
							if (btn) btn.disabled = !(confirmChk && confirmChk.checked);
							return;
						}
					}

                    if (typeof var_from_php === 'undefined' || !var_from_php.ajax_url) return;

                    const fd = new FormData(form);
                    fd.append('action', 'corppix_contact_form_order_submit');
                    if (btn) btn.disabled = true;

                    fetch(var_from_php.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: fd,
                    })
                        .then((r) => r.json())
                        .then((data) => {
                            if (data.success) {
                                form.reset();
                                if (confirmChk) confirmChk.checked = false;
                                if (btn) btn.disabled = true;
								if (typeof window.corppixTurnstileResetForm === 'function') {
									window.corppixTurnstileResetForm(form);
								}
                                setMsg('', false);
                                if (typeof window.corppixOpenPopupById === 'function') {
                                    window.corppixOpenPopupById('main_form_success_popup');
                                }
                            } else {
                                const m = data.data && data.data.message ? data.data.message : t( 'form_submit_error', 'Помилка відправки. Спробуйте пізніше.' );
                                setMsg(m, true);
                            }
                        })
                        .catch(() => {
                            setMsg( t( 'form_network_error', 'Помилка мережі. Спробуйте пізніше.' ), true );
                        })
                        .finally(() => {
                            if (btn) btn.disabled = !(confirmChk && confirmChk.checked);
                        });
                } break;
                case 'login-user': {
                    event.preventDefault();
                    const data = new FormData(submitElem);
                    data.append( 'action', 'login_user' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if(responseData.success) {
                                    location.href = var_from_php.site_url;
                                } else {
                                    const loginMessage = document.querySelector('.js-login-message');
                                    const message = responseData.data.message;
                                    
                                    if (loginMessage && message) {
                                        loginMessage.innerText = message;
                                    }
                                }
                            })
                } break;
			}
		});

		(function corppixSetupCodThanksHomePopup() {
			if ( typeof var_from_php === 'undefined' || ! var_from_php.checkout_cod_thanks_param ) {
				return;
			}
			const param = String( var_from_php.checkout_cod_thanks_param );
			const thanksPopup = document.getElementById( 'main_form_success_popup' );
			const thanksTextEl = thanksPopup ? thanksPopup.querySelector( '.popup-success__text' ) : null;
			let thanksDefaultHtml = null;
			if ( thanksTextEl ) {
				thanksDefaultHtml = thanksTextEl.innerHTML;
			}
			function stripCodThanksFromUrl() {
				try {
					const u = new URL( window.location.href );
					if ( u.searchParams.get( param ) !== '1' ) {
						return;
					}
					u.searchParams.delete( param );
					const next = u.pathname + ( u.search ? u.search : '' ) + u.hash;
					window.history.replaceState( null, '', next );
				} catch ( stripErr ) {
				}
			}
			function restoreThanksPopupText() {
				if ( thanksTextEl && thanksDefaultHtml !== null ) {
					thanksTextEl.innerHTML = thanksDefaultHtml;
				}
			}
			let hasCodThanksParam = false;
			try {
				const u0 = new URL( window.location.href );
				hasCodThanksParam = u0.searchParams.get( param ) === '1';
			} catch ( urlErr ) {
				return;
			}
			if ( hasCodThanksParam ) {
				requestAnimationFrame( function () {
					if ( thanksTextEl && var_from_php.checkout_cod_thanks_message ) {
						thanksTextEl.textContent = String( var_from_php.checkout_cod_thanks_message );
					}
					if ( typeof window.corppixOpenPopupById === 'function' ) {
						window.corppixOpenPopupById( 'main_form_success_popup' );
					}
				} );
			}
			if ( ! thanksPopup ) {
				return;
			}
			document.body.addEventListener(
				'click',
				function corppixCodThanksCloseHandler( ev ) {
					const btn = ev.target.closest && ev.target.closest( '[data-role="close-popup"]' );
					if ( ! btn || ! thanksPopup.contains( btn ) ) {
						return;
					}
					window.setTimeout( function () {
						stripCodThanksFromUrl();
						restoreThanksPopupText();
					}, 0 );
				},
				false
			);
		})();

	});


	// Use it when you need to know that everything is loaded (html, styles, images)
	window.addEventListener('load', (event) => {});
    
    function corppixScrollToProductsListBlock() {
        const block = document.querySelector( '.products-list' );
        if ( ! block ) {
            return;
        }
        const header = document.querySelector( 'header.site-header' );
        const headerH = header ? header.offsetHeight : 0;
        const rect = block.getBoundingClientRect();
        const y = rect.top + window.scrollY - headerH - 16;
        window.scrollTo( { top: Math.max( 0, y ), behavior: 'smooth' } );
    }

    // Load filtered products via AJAX (page 1 on filter change, or specific page on pagination)
    function loadFilteredProducts( page = 1, options = {} ) {
        const scrollToBlock = !!( options && options.scrollToBlock );
        const wrap = document.querySelector('.products-list__wrap');
        const paginationWrap = document.querySelector('.js-products-pagination');
        if (!wrap) return;

        const form = document.querySelector('[data-role="filter-product"]');
        const searchInput = document.querySelector('.search-input');
        const formData = new FormData();
        formData.append('action', 'ajax_filter_products');
        formData.append('page', String(page));
        formData.append('search', (searchInput?.value || '').trim());
        if (form) {
            const priceFrom = form.querySelector('input[name="price-from"]');
            const priceTo = form.querySelector('input[name="price-to"]');
            formData.append('price_from', priceFrom?.value?.trim() || '');
            formData.append('price_to', priceTo?.value?.trim() || '');
            form.querySelectorAll('input[name="color[]"]:checked').forEach(inp => {
                formData.append('color[]', inp.value);
            });
            form.querySelectorAll('input[name="model[]"]:checked').forEach(inp => {
                formData.append('model[]', inp.value);
            });
            const sortRadio = form.querySelector('input[name="sort"]:checked');
            if (sortRadio) formData.append('sort', sortRadio.value);
        }

        wrap.style.opacity = '0.6';
        wrap.style.pointerEvents = 'none';
        if (paginationWrap) paginationWrap.style.visibility = 'hidden';

        fetch(var_from_php.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        })
            .then(r => r.json())
            .then(data => {
                wrap.style.opacity = '';
                wrap.style.pointerEvents = '';
                if (paginationWrap) paginationWrap.style.visibility = '';
                if (data.success && data.data) {
                    wrap.innerHTML = data.data.html || '';
                    if (paginationWrap) paginationWrap.innerHTML = data.data.pagination || '';
                    lazyImage( wrap );
                    animateBlock();
                    if ( scrollToBlock ) {
                        window.requestAnimationFrame( () => {
                            corppixScrollToProductsListBlock();
                        } );
                    }
                }
            })
            .catch(() => {
                wrap.style.opacity = '';
                wrap.style.pointerEvents = '';
                if (paginationWrap) paginationWrap.style.visibility = '';
            });
    }

    const debouncedLoadFilter = debounce(() => {
        if (typeof loadFilteredProducts === 'function') loadFilteredProducts(1);
    }, 400);

    window.corppixSkipNextSortChangeLoad = false;

    function corppixGetSortRadioFromEventTarget( el ) {
        if ( ! el || ! el.closest ) {
            return null;
        }
        const direct = el.closest( 'input[name="sort"][data-role="change-filter"]' );
        if ( direct ) {
            return direct;
        }
        const lab = el.closest( 'label' );
        return lab ? lab.querySelector( 'input[name="sort"][data-role="change-filter"]' ) : null;
    }

    document.body.addEventListener( 'mousedown', ( e ) => {
        const inp = corppixGetSortRadioFromEventTarget( e.target );
        if ( ! inp || ! inp.closest( '[data-role="filter-product"]' ) ) {
            return;
        }
        inp.dataset.corppixSortDownChecked = inp.checked ? '1' : '0';
    }, true );

    document.body.addEventListener( 'click', ( e ) => {
        const inp = corppixGetSortRadioFromEventTarget( e.target );
        if ( ! inp || ! inp.closest( '[data-role="filter-product"]' ) ) {
            return;
        }
        const was = inp.dataset.corppixSortDownChecked;
        if ( was !== undefined ) {
            delete inp.dataset.corppixSortDownChecked;
        }
        if ( was !== '1' ) {
            return;
        }
        window.corppixSkipNextSortChangeLoad = true;
        inp.checked = false;
        e.preventDefault();
        e.stopPropagation();
        updateCheckedFilters();
        if ( typeof loadFilteredProducts === 'function' ) {
            loadFilteredProducts( 1 );
        }
        window.setTimeout( () => {
            window.corppixSkipNextSortChangeLoad = false;
        }, 0 );
    }, true );

    // Update checked filters chips (price: input, color/model/sort: change)
    function updateCheckedFilters() {
        const form = document.querySelector('[data-role="filter-product"]');
        const container = document.querySelector('.checked-filters');
        if (!form || !container) return;
        
        const chips = [];
        const priceFrom = form.querySelector('input[name="price-from"]');
        const priceTo = form.querySelector('input[name="price-to"]');
        const fromVal = priceFrom?.value?.trim();
        const toVal = priceTo?.value?.trim();
        
        if (fromVal || toVal) {
            const label = fromVal && toVal
                    ? `${fromVal} - ${toVal} грн`
                    : fromVal ? `${fromVal} грн` : `- ${toVal} грн`;
            chips.push({ type: 'price', label, value: 'price' });
        }
        
        form.querySelectorAll('input[name="color[]"]:checked').forEach(inp => {
            const hex = inp.dataset.colorHex || '#C4A57B';
            const name = inp.dataset.colorName || inp.value;
            chips.push({ type: 'color', label: name, value: inp.value, hex });
        });
        
        form.querySelectorAll('input[name="model[]"]:checked').forEach(inp => {
            const labelEl = inp.closest('label')?.querySelector('span');
            const name = labelEl?.textContent?.trim() || inp.value;
            chips.push({ type: 'model', label: name, value: inp.value });
        });
        
        const sortRadio = form.querySelector('input[name="sort"]:checked');
        if (sortRadio) {
            const labelEl = sortRadio.closest('label')?.querySelector('span');
            const name = labelEl?.textContent?.trim() || sortRadio.value;
            chips.push({ type: 'sort', label: name, value: sortRadio.value });
        }
        
        const xIcon = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L1 11M1 1L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        container.innerHTML = chips.map(c => {
            const safeVal = (c.value || '').replace(/"/g, '&quot;');
            const safeLabel = (c.label || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            const swatch = c.type === 'color'
                    ? `<span class="h-[30px] w-[30px] shrink-0 rounded-full border border-[#D9D9D9]" style="background-color:${(c.hex || '#C4A57B').replace(/"/g, '')}" aria-hidden="true"></span>`
                    : '';
            return `<div class="filter-chip flex items-center gap-[10px] px-[17px] h-[53px] bg-green text-dark text-[16px] font-2" data-filter-type="${c.type}" data-filter-value="${safeVal}">
					${swatch}
					<span>${safeLabel}</span>
					<button type="button" data-role="remove-filter" class="ml-[4px] p-0 border-0 bg-transparent cursor-pointer text-dark hover:opacity-70 flex items-center" aria-label="Remove filter">${xIcon}</button>
				</div>`;
        }).join('');
    }
    
    function clearPersonalizationFilePreview(wrap) {
        const preview = wrap.querySelector('.js-personalization-file-preview');
        if (!preview) return;
        const prevUrl = preview.dataset.blobUrl;
        if (prevUrl) {
            URL.revokeObjectURL(prevUrl);
            delete preview.dataset.blobUrl;
        }
        const img = preview.querySelector('.js-personalization-file-preview-img');
        if (img) {
            img.removeAttribute('src');
            img.alt = '';
        }
        preview.classList.add('hidden');
    }
    
    function removePersonalizationSelectedFile(wrap) {
        clearPersonalizationFilePreview(wrap);
        const file = wrap.querySelector('.js-personalization-file');
        if (file) file.value = '';
    }
    
    function syncSingleProductPersonalizationUi(wrap, enabled) {
        const fields = wrap.querySelector('.js-personalization-fields');
        const productPage = wrap.closest('.product-page');
        
        if (fields) {
            fields.classList.toggle('hidden', !enabled);
            fields.querySelectorAll('textarea, input[type="file"], input.js-personalization-place').forEach((inp) => {
                inp.disabled = !enabled;
            });
            if (!enabled) {
                const ta = fields.querySelector('.js-personalization-text');
                if (ta) ta.value = '';
                removePersonalizationSelectedFile(wrap);
                fields.querySelectorAll('.js-personalization-place').forEach((r) => {
                    r.checked = false;
                });
            } else {
                const placeRadios = fields.querySelectorAll('.js-personalization-place');
                const anyPlaceChecked = Array.from(placeRadios).some((r) => r.checked);
                if (!anyPlaceChecked && placeRadios[0]) {
                    placeRadios[0].checked = true;
                }
            }
        }
        
        if (productPage) {
            const termsNo = productPage.querySelector('.js-personalization-terms-no');
            const termsYes = productPage.querySelector('.js-personalization-terms-yes');
            if (termsNo) termsNo.classList.toggle('hidden', !!enabled);
            if (termsYes) termsYes.classList.toggle('hidden', !enabled);
            productPage.querySelectorAll('.js-personalization-condition-extra').forEach((el) => {
                el.classList.toggle('hidden', !enabled);
            });
        }
    }
    
    function resetSingleProductAfterSuccessfulAddToCart(productPage) {
        if (!productPage) return;
        
        const qtyInput = productPage.querySelector('.js-single-qty-input');
        if (qtyInput) qtyInput.value = '1';
        
        const pers = productPage.querySelector('.js-single-personalization');
        if (pers) {
            const noRadio = pers.querySelector('.js-personalization-toggle[value="0"]');
            if (noRadio) noRadio.checked = true;
            const minMsg = pers.querySelector('.js-personalization-min-qty');
            if (minMsg) minMsg.classList.add('hidden');
            syncSingleProductPersonalizationUi(pers, false);
        }
        
        const colorsWrap = productPage.querySelector('.js-single-product-variation-colors');
        if (colorsWrap) {
            const defaultOpt = colorsWrap.querySelector('.js-single-variation-option[data-is-default="1"]');
            if (defaultOpt) {
                defaultOpt.click();
            }
        } else {
            const addBtn = productPage.querySelector('.js-single-add-to-cart');
            if (addBtn) {
                addBtn.dataset.variationId = '0';
                addBtn.disabled = false;
            }
            const hid = productPage.querySelector('.js-single-selected-variation-id');
            if (hid) hid.value = '0';
            const qSrc = productPage.querySelector('.js-single-quick-order-source');
            if (qSrc && qSrc.dataset.baseName) {
                qSrc.dataset.currentDisplayName = qSrc.dataset.baseName;
            }
        }
    }

})( jQuery );


function close_popups () {
    const popups = document.querySelectorAll('.js-popup');
    const body = document.querySelector('body');
    if(popups) {
        popups.forEach( item => {
            item.classList.remove('show');
			if ( item.id === 'cart_item_edit_popup' || item.id === 'main_form_success_popup' || item.id === 'quick_order_popup' || item.id === 'quick-order-success' ) {
				item.setAttribute( 'aria-hidden', 'true' );
			}
        })
        
        body && body.classList.remove('menu-open');
    }
}

function corppixOpenPopupById( id ) {
	const popup = document.querySelector( '#' + id );
	close_popups();
	if ( popup ) {
		popup.classList.add( 'show' );
		if ( id === 'cart_item_edit_popup' || id === 'main_form_success_popup' || id === 'quick_order_popup' || id === 'quick-order-success' ) {
			popup.setAttribute( 'aria-hidden', 'false' );
		}
	}
}

window.corppixOpenPopupById = corppixOpenPopupById;
window.corppixCloseAllPopups = close_popups;
